// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:57:40.296Z
// Property: Zinfandel Village Apartments (ID: 6767906449166882)
// Collections: 20 amenities, 4 floorplans (live), 10 photos, 84 POIs, 4 reviews, 5 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166882",
  "property_external_id": "495845",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/zinfandel-village-apartments-rancho-cordova-ca/tmyc6k9/",
  "property_google_business_url": "https://www.google.com/maps/place/Zinfandel+Village+Apartments/data=!4m2!3m1!1s0x0:0x4f1b3c078558bb88?sa=X&ved=2ahUKEwjBxtvWgrySAxVnRPEDHR9YLR8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "51978104245",
  "property_crm_software": "RentCafe CRM",
  "property_pm_software": "Yardi",
  "property_pm_info": "495845 p0505513",
  "property_status": null,
  "property_slug": "zinfandel-village-apartments",
  "property_name": "Zinfandel Village Apartments",
  "property_website_url": "www.rancho-cordova-apartments.com",
  "property_domain": null,
  "property_address": "3500 Data Drive",
  "property_full_address": "3500 Data Dr, Rancho Cordova, CA 95670",
  "property_address_1": "3500 Data Drive",
  "property_address_2": null,
  "property_address_city": "Rancho Cordova",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95670",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "Outer Rancho Cordova",
  "property_address_latitude": "38.5805727",
  "property_address_longitude": "-121.2958622",
  "property_email": "zinfandelvillage@ctlmanagement.com",
  "property_phone": "(279) 263-8376",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Zinfandel Village Apartments in Rancho Cordova, CA, experience stylish living with floor plans ranging from cozy one-bedroom retreats to spacious three-bedroom homes. Enjoy exceptional amenities like a serene Bark Park, convenient online services, and vibrant resident activities. Your perfect home awaits—explore our availability or schedule a tour today!",
  "property_long_description": "Welcome to Zinfandel Village Apartments, your ideal sanctuary in the heart of Rancho Cordova, CA. Offering a diverse selection of floor plans including one, two, and three-bedroom apartments, Zinfandel Village is designed to meet your lifestyle needs. Each home features spacious kitchens perfect for culinary enthusiasts, built-in vanities in primary bedrooms*, and organized closet systems that maximize your living space. \n\nEmbrace a vibrant community with our resident activity program, ensuring there’s always something engaging happening just outside your door. Enjoy the convenience of online rent payments and service requests that simplify your daily life. For our furry friends, our Bark Park provides a safe and fun space to play and mingle. \n\nUnwind at our cozy coffee bar or take advantage of our state-of-the-art 24-hour package lockers for all your online shopping needs. We also offer garages for those needing extra storage and a smoke-free living environment, promoting a healthy, clean lifestyle. \n\nDiscover a perfect blend of comfort and modern amenities at Zinfandel Village Apartments, where community and convenience come together seamlessly. Find your new home today—browse our apartment availability or schedule a personal tour to experience our welcoming community firsthand! Your next chapter begins at Zinfandel Village!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019db198-93ba-7171-aa64-e67f51bb8d85.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area surrounded by trees and apartment buildings.",
    "public_id": "019db198-93ba-7171-aa64-e67f51bb8d85",
    "storage_key": "property/6767906449166882/019db198-93ba-7171-aa64-e67f51bb8d85.webp",
    "width": 1500,
    "height": 759
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "364",
  "property_year_built": "1989",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.6043956043956",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet",
  "property_online_leasing_url": "https://rancho-cordova-apartments.securecafe.com/onlineleasing/zinfandel-village-0/floorplans.aspx",
  "property_resident_portal_url": "https://rancho-cordova-apartments.securecafe.com/residentservices/zinfandel-village-0/userlogin.aspx",
  "property_apply_now_url": "https://rancho-cordova-apartments.securecafe.com/onlineleasing/zinfandel-village-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019db14d-aa20-76fc-b3c7-3dd566bc8dee.webp",
  "property_primary_logo_media": {
    "alt_text": "Zinfandel Village Apartments logo",
    "public_id": "019db14d-aa20-76fc-b3c7-3dd566bc8dee",
    "storage_key": "property/6767906449166882/019db14d-aa20-76fc-b3c7-3dd566bc8dee.webp",
    "width": 1652,
    "height": 320
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019db1a4-0f65-767f-b874-242685eaa7c0.webp",
  "property_secondary_logo_media": {
    "alt_text": "Zinfandel Village Apartments logo",
    "public_id": "019db1a4-0f65-767f-b874-242685eaa7c0",
    "storage_key": "property/6767906449166882/019db1a4-0f65-767f-b874-242685eaa7c0.webp",
    "width": 813,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019db14f-1146-7614-bcd4-22f88e4e1b80.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Graphic with dark gray bars and a white bar in the middle.",
    "public_id": "019db14f-1146-7614-bcd4-22f88e4e1b80",
    "storage_key": "property/6767906449166882/019db14f-1146-7614-bcd4-22f88e4e1b80.webp",
    "width": 1280,
    "height": 247
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019db14f-04c8-7664-919a-20cbc69ed3f0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Generic graphic element, black rectangle on white background.",
    "public_id": "019db14f-04c8-7664-919a-20cbc69ed3f0",
    "storage_key": "property/6767906449166882/019db14f-04c8-7664-919a-20cbc69ed3f0.webp",
    "width": 1280,
    "height": 247
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "615 - 1022",
  "property_sqft_min": "615",
  "property_sqft_max": "1022",
  "property_price_range": "1545 - 2820",
  "property_price_min": "1545",
  "property_price_max": "2820",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/zinfandelvillageapartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJY8-WPTvdmoARiLtYhQc8G08",
  "property_youtube_url": "https://www.youtube.com/watch?v=cZTvR-WXt4c",
  "property_yelp_url": "https://www.yelp.com/biz/zinfandel-ranch-apartments-rancho-cordova",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Zinfandel Village Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Zinfandel Village Apartments in beautiful Rancho Cordova, CA, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, and enjoy amenities like a vibrant resident activity program, a cozy coffee bar, and a bark park. Experience effortless living today!",
  "property_home_floorplans_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, your ideal home awaits. Choose from spacious one, two, or three-bedroom floor plans that blend comfort and style. Each layout promises a unique living experience. Dive into our offerings and secure your dream apartment today! Explore the possibilities with us.",
  "property_home_gallery_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, embrace comfort and convenience with spacious one, two, and three-bedroom floor plans. Enjoy a vibrant resident activity program, a cozy coffee bar, and hassle-free online services. Experience the perfect blend of style and amenities—picture yourself living here and elevating your lifestyle!",
  "property_home_neighborhood_blurb": "Welcome to Zinfandel Village Apartments in vibrant Rancho Cordova, CA, where comfort meets convenience. Nestled near parks and educational hubs, enjoy easy access to River Bend Park, American River College, and the California State Railroad Museum. Experience a community rich in culture and recreation—your ideal lifestyle awaits!",
  "property_home_reviews_blurb": "Welcome to Zinfandel Village Apartments, where our residents thrive! With a 5-star rating, they rave about our friendly staff and convenient amenities. One happy resident said, “The office is quick to help,” ensuring a seamless living experience. Enjoy spacious units, outdoor pools, and a welcoming community in Rancho Cordova, CA.",
  "property_neighborhood_blurb": "Experience the vibrant heart of Rancho Cordova at Zinfandel Village Apartments. Nestled close to top schools, parks, and cultural attractions, our community offers easy access to local gems like the California State Railroad Museum and Sunrise Recreation Area. Immerse yourself in a lively neighborhood where convenience meets adventure.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, comfort meets convenience. Enjoy spacious floor plans, including one, two, and three bedrooms, alongside unique amenities like a Bark Park, coffee bar, and 24-hour package lockers. Elevate your lifestyle—check out our remarkable community features and make your home here today!",
  "property_applynow_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, elevate your living experience with versatile one, two, and three-bedroom floor plans. Enjoy a smoke-free haven featuring spacious kitchens, a relaxing coffee bar, and a resident activity program. Plus, take advantage of online services for hassle-free living. Find your new home and lease online today!",
  "property_contactus_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, spacious living awaits with thoughtfully designed floor plans, including one, two, and three-bedroom options. Each residence combines comfort and style, perfect for every lifestyle. Have questions? Our leasing team is ready to assist you—reach out today!",
  "property_faqs_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, we offer a range of spacious floor plans to suit your lifestyle—from cozy one-bedroom retreats to expansive three-bedroom homes. Curious about our community? Browse our FAQs page to uncover everything you need to know about living here!",
  "property_floorplans_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, a variety of thoughtfully designed floor plans await you. Whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven, each layout is crafted for comfort and style. Browse our available apartment homes and find the perfect fit for your lifestyle. ",
  "property_gallery_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, vibrant living awaits! Picture spacious floor plans equipped with modern amenities like a bark park and a cozy coffee bar. With sleek kitchens, resident programs, and convenient online services, your ideal home is just a snapshot away. Come envision your future here!",
  "property_interactivemap_blurb": "Welcome to Zinfandel Village Apartments in Rancho Cordova, CA, where modern living meets unique style. Enjoy spacious one, two, and three-bedroom floor plans enhanced by premium amenities. From our inviting coffee bar to the bustling resident activity program, your perfect home awaits. Use our interactive community map to find your ideal space today!",
  "property_pets_blurb": "At Zinfandel Village Apartments in Rancho Cordova, we understand pets are family. Enjoy comfortable living with your indoor adult cats and small dogs under 25 lbs. Our vibrant pet-friendly community also accommodates a variety of small caged animals. Experience a seamless blend of comfort and companionship today!",
  "property_referafriend_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, living is a shared joy. Whether it's a cozy one-bedroom or a spacious three-bedroom, our inviting floor plans cater to your lifestyle. Bring a friend to enjoy our vibrant community—because great friends make the best neighbors! Refer someone special today!",
  "property_residentaccess_blurb": "At Zinfandel Village Apartments in Rancho Cordova, CA, residents enjoy spacious one, two, and three-bedroom floor plans tailored for modern living. Log into your resident portal for seamless rent payments, easy maintenance requests, and a host of community features designed for your convenience and comfort.",
  "property_reviews_blurb": "At Zinfandel Village Apartments in Rancho Cordova, our residents rave about the caring staff and exceptional amenities. One happy resident said, “The office is quick to help with any issues,” highlighting our commitment to quality service. Join a community that values your happiness and delivers an amazing living experience!",
  "property_created_at": "1762784637331",
  "property_scheduletour_blurb": "At Zinfandel Village Apartments in vibrant Rancho Cordova, CA, choose from thoughtfully designed one, two, and three-bedroom floor plans tailored to suit your lifestyle. Ready for your personal tour? Hear firsthand from our residents why they love calling our community home! Schedule a visit today and feel the difference!",
  "property_thankyou_blurb": "Thank you for reaching out to Zinfandel Village Apartments in beautiful Rancho Cordova, CA! Our diverse floor plans – from cozy one-bedroom to spacious three-bedroom options – cater to every lifestyle. A team member will be in touch soon to assist you in finding your perfect home. Stay tuned!",
  "property_virtualtours_blurb": "Step into a world of comfort at Zinfandel Village Apartments in Rancho Cordova, CA. With diverse floor plans—one, two, and three bedrooms—there's a perfect space waiting for you. Experience the ambiance firsthand; take a virtual tour of our vibrant community and find your ideal home today!",
  "property_copyright": "2025 All Rights Reserved. Zinfandel Village Apartments",
  "property_seo_title_home": "Zinfandel Village Apartments |  Apartments in Rancho Cordova, CA",
  "property_seo_description_home": "Welcome to Zinfandel Village Apartments in Rancho Cordova! Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Rancho Cordova, CA Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal home at Zinfandel Village Apartments in Rancho Cordova! Choose from stylish one, two, and three-bedroom layouts.",
  "property_seo_title_amenities": "Amenities | Rancho Cordova, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant life at Zinfandel Village Apartments in Rancho Cordova! Enjoy spacious layouts, a coffee bar, a bark park, and exclusive resident perks!",
  "property_seo_title_gallery": "Gallery | Apartments in Rancho Cordova, CA",
  "property_seo_description_gallery": "Explore Zinfandel Village in Rancho Cordova through our photo gallery featuring spacious layouts, vibrant amenities, and a welcoming community!",
  "property_seo_title_virtualtours": "Virtual Tours | Zinfandel Village Apartments Apartments",
  "property_seo_description_virtualtours": "Step into Zinfandel Village Apartments in Rancho Cordova, CA! Enjoy a virtual tour of our charming one, two, and three-bedroom homes. Your new life awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Zinfandel Village Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Zinfandel Village Apartments in Rancho Cordova! Explore our spacious floor plans and amenities with our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rancho Cordova, CA",
  "property_seo_description_neighborhood": "Discover Rancho Cordova living at Zinfandel Village Apartments, with local gems and attractions just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Zinfandel Village Apartments",
  "property_seo_description_contact": "Discover comfortable living at Zinfandel Village Apartments in Rancho Cordova, CA. Contact our leasing team for info on your future home!",
  "property_seo_title_faqs": "FAQs | Apartments in Rancho Cordova, CA",
  "property_seo_description_faqs": "Find answers to all your questions about Zinfandel Village Apartments in Rancho Cordova, CA. Explore our amenities, floor plans, and more today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rancho Cordova, CA",
  "property_seo_description_reviews": "Read real experiences from Zinfandel Village residents in Rancho Cordova! Discover why our spacious floor plans and amenities make us the perfect home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Rancho Cordova, CA",
  "property_seo_description_applynow": "At Zinfandel Village Apartments, Rancho Cordova, enjoy spacious living with modern amenities. Apply now for your perfect 1, 2, or 3-bedroom home!",
  "property_seo_title_residentaccess": "Resident Access | Zinfandel Village Apartments",
  "property_seo_description_residentaccess": "Log in to Zinfandel Village Apartments' resident portal for easy rent payments, maintenance requests, and exclusive community updates in Rancho Cordova, CA!",
  "property_seo_title_referafriend": "Refer A Friend | Zinfandel Village Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors at Zinfandel Village Apartments! Refer a friend to our Rancho Cordova community and enjoy unbeatable living together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Zinfandel Village Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Zinfandel Village Apartments in Rancho Cordova, CA. Schedule your tour today and find your perfect home in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Zinfandel Village Apartments",
  "property_seo_description_privacy": "Your privacy matters at Zinfandel Village Apartments in Rancho Cordova, CA. Learn how we protect your information. Read our privacy policy for details!",
  "property_seo_title_accessibility": "Website Accessibility | Zinfandel Village Apartments",
  "property_seo_description_accessibility": "Discover modern living at Zinfandel Village Apartments in Rancho Cordova, CA—where accessibility and a vibrant community await you!",
  "property_seo_title_sitemap": "Sitemap | Zinfandel Village Apartments",
  "property_seo_description_sitemap": "Navigate your way to the perfect home at Zinfandel Village Apartments in Rancho Cordova, CA. Check out our sitemap for a seamless search experience!",
  "property_seo_title_thankyou": "Thank You | Zinfandel Village Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Zinfandel Village Apartments! Our team will be in touch soon to help you find your ideal home in beautiful Rancho Cordova, CA.",
  "property_seo_title_pets": "Pet Policy | Apartments in Rancho Cordova, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874683056",
  "amenities": [
    {
      "id": "ec_3ebf6782941aaf3f436c1882",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429674",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-22c4-7366-bf7b-3d4e877594e5.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with a stone fireplace, sectional sofa, coffee table, and kitchen counter with bar stools.",
        "public_id": "019eb028-22c4-7366-bf7b-3d4e877594e5",
        "storage_key": "property/6767906449166882/019eb028-22c4-7366-bf7b-3d4e877594e5.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A clubhouse with a stone fireplace and a couch at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ccb7af7753fa86353aa712c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429673",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-20ed-7720-aa88-387e5362a710.webp",
      "amenity_image_media": {
        "alt_text": "Business center with a leather couch, desk with computer and printer, and chairs near windows.",
        "public_id": "019eb028-20ed-7720-aa88-387e5362a710",
        "storage_key": "property/6767906449166882/019eb028-20ed-7720-aa88-387e5362a710.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A business center with a black couch, a wooden coffee table, and a carpet on the floor at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bf648e2a00d340f1b829a90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429671",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-22c3-72eb-8afa-ba549c08fb4d.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with weight machine, treadmill, elliptical, and stationary bike.",
        "public_id": "019eb028-22c3-72eb-8afa-ba549c08fb4d",
        "storage_key": "property/6767906449166882/019eb028-22c3-72eb-8afa-ba549c08fb4d.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A gym with a variety of equipment at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e777314da24da43b6fbb7b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429672",
      "title": "2 Sparkling Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-2b50-75dd-a71d-31dcdbe6c73b.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool with lounge chairs and seating area.",
        "public_id": "019eb028-2b50-75dd-a71d-31dcdbe6c73b",
        "storage_key": "property/6767906449166882/019eb028-2b50-75dd-a71d-31dcdbe6c73b.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A large outdoor swimming pool surrounded by trees and lounge chairs at Zinfandel Village Apartments, California, 95670,A swimming pool and clubhouse at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5564295b1b2972da1a827784",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429678",
      "title": "2 Spas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de7434bf21a4d48a53c7f581",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429677",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-5875-765d-8925-6153ac7168bb.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slide and benches next to apartment buildings.",
        "public_id": "019d08aa-5875-765d-8925-6153ac7168bb",
        "storage_key": "property/6767906449166882/019d08aa-5875-765d-8925-6153ac7168bb.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Playground & Bench at Zinfandel Village Apartments, Rancho Cordova",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0401c8c12325407577d9808d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "86393182",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f794933e7fbcc1bfaea45582",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "86393184",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-3c5f-706a-ab12-90e1d79192a5.webp",
      "amenity_image_media": {
        "alt_text": "Secure package lockers for residents",
        "public_id": "019d08aa-3c5f-706a-ab12-90e1d79192a5",
        "storage_key": "property/6767906449166882/019d08aa-3c5f-706a-ab12-90e1d79192a5.webp",
        "width": 1500,
        "height": 1001
      },
      "amenity_image_alt_text": "24 Hour Package Lockers at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_884770e667eb09363705a59c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "85754426",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-21f0-75bb-87fb-2cef3cb89e83.webp",
      "amenity_image_media": {
        "alt_text": "Apartment building exterior with a dog park in the foreground.",
        "public_id": "019eb028-21f0-75bb-87fb-2cef3cb89e83",
        "storage_key": "property/6767906449166882/019eb028-21f0-75bb-87fb-2cef3cb89e83.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A dog park with a green barrel and two blue rings in front of apartment buildings at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c16b29dbf3b402f712f8d3fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "86393183",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-62b1-75ff-b20d-a3175a3a4ca0.webp",
      "amenity_image_media": {
        "alt_text": "Garages at the property entrance.",
        "public_id": "019d08aa-62b1-75ff-b20d-a3175a3a4ca0",
        "storage_key": "property/6767906449166882/019d08aa-62b1-75ff-b20d-a3175a3a4ca0.webp",
        "width": 1500,
        "height": 1001
      },
      "amenity_image_alt_text": "Garages at Zinfandel Village Apartments, Rancho Cordova, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95b62cc35d2bcecc4c46f9df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429676",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4e4becfba2ee19c1f7932f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "82390318",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41173f9bc5ab88d49f55d154",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "82390320",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e80dd75255f054d520dd589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "86393185",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eaa19c2a565767c535e36286",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429682",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-4066-71a6-a8ae-75c255333ef4.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, black countertops, a black refrigerator, and a stove.",
        "public_id": "019eb028-4066-71a6-a8ae-75c255333ef4",
        "storage_key": "property/6767906449166882/019eb028-4066-71a6-a8ae-75c255333ef4.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A kitchen with white cabinets and a black stove top at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_120f92c146131e0909e56248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429679",
      "title": "Centralized Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36af7003df0be067c6843523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429681",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c33b8a2fc156e811ba6b29f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "81300410",
      "title": "Spacious Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-41fb-71cf-acd7-4291c3328d16.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and living area with sofa and coffee table.",
        "public_id": "019eb028-41fb-71cf-acd7-4291c3328d16",
        "storage_key": "property/6767906449166882/019eb028-41fb-71cf-acd7-4291c3328d16.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A kitchen with black appliances and white cabinets at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f4c06d406e92aad61402b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "80429680",
      "title": "Closet Organizers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-3fc3-74fa-a9e2-be4d3e9688d3.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a closet and a desk with a chair.",
        "public_id": "019eb028-3fc3-74fa-a9e2-be4d3e9688d3",
        "storage_key": "property/6767906449166882/019eb028-3fc3-74fa-a9e2-be4d3e9688d3.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A bedroom with a bed, desk, chair, and a painting on the wall at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b4b985db1051d2481a4d9f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "yardi",
      "external_id": "87311408",
      "title": "Built-In Vanity In Primary Bedroom - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019eb028-4589-75ba-bb37-9764cc99991c.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a closet and an ensuite bathroom vanity.",
        "public_id": "019eb028-4589-75ba-bb37-9764cc99991c",
        "storage_key": "property/6767906449166882/019eb028-4589-75ba-bb37-9764cc99991c.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A bedroom with a bed, vanity, and a painting on the wall at Zinfandel Village Apartments, California, 95670,A bedroom with a bed, vanity, and a painting on the wall at Zinfandel Village Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_829f0502-0f10-4080-a154-62793dbdf4d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-3304-710b-9826-0311cfb62cbd.webp",
      "image_media": {
        "alt_text": "Building exterior of apartment complex with palm trees and leasing office sign.",
        "public_id": "019d08aa-3304-710b-9826-0311cfb62cbd",
        "storage_key": "property/6767906449166882/019d08aa-3304-710b-9826-0311cfb62cbd.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Welcome to the leasing office of our apartment community, surrounded by lush greenery and palm trees.",
      "link": "",
      "alt_text": "Building exterior of apartment complex with palm trees and leasing office sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb611ae2-cbb3-40ed-9c09-136d0f9f063d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-230c-750b-9133-dfe9472dbb85.webp",
      "image_media": {
        "alt_text": "Property management office reception area with coffee station and seating.",
        "public_id": "019d08aa-230c-750b-9133-dfe9472dbb85",
        "storage_key": "property/6767906449166882/019d08aa-230c-750b-9133-dfe9472dbb85.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Welcome to our leasing office, featuring a comfortable waiting area with complimentary beverages and friendly staff.",
      "link": "",
      "alt_text": "Property management office reception area with coffee station and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67639e7b-c888-43c7-a1e7-9d1bb385dbe3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-1f23-7435-afb1-3dd807e7baa5.webp",
      "image_media": {
        "alt_text": "Community lounge area with a stone fireplace, comfortable seating, and a full-service kitchen.",
        "public_id": "019d08aa-1f23-7435-afb1-3dd807e7baa5",
        "storage_key": "property/6767906449166882/019d08aa-1f23-7435-afb1-3dd807e7baa5.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Relax and unwind in our community lounge, featuring a cozy stone fireplace and a convenient full-service kitchen. Perfect for gatherings or quiet evenings.",
      "link": "",
      "alt_text": "Community lounge area with a stone fireplace, comfortable seating, and a full-service kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e2b53496-cdef-406b-93ac-f034cd36ffac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-2556-706f-a5de-6f7d07287cbc.webp",
      "image_media": {
        "alt_text": "Swimming pool and hot tub with lounge chairs and seating area in front of apartment buildings.",
        "public_id": "019d08aa-2556-706f-a5de-6f7d07287cbc",
        "storage_key": "property/6767906449166882/019d08aa-2556-706f-a5de-6f7d07287cbc.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool or relax in the soothing hot tub. Plenty of lounge chairs and a shaded seating area are available for your comfort.",
      "link": "",
      "alt_text": "Swimming pool and hot tub with lounge chairs and seating area in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf4b812e-3ce3-4096-b58e-1b7ecf876d3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-2dff-7134-aaf7-059e7bdcf112.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and umbrellas",
        "public_id": "019d08aa-2dff-7134-aaf7-059e7bdcf112",
        "storage_key": "property/6767906449166882/019d08aa-2dff-7134-aaf7-059e7bdcf112.webp",
        "width": 1003,
        "height": 658
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool and soothing hot tub, surrounded by lush greenery and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d499cd1-0047-4c53-9688-1f6807435916",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-3a2e-7078-a57e-594562c6b6e1.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and tables surrounding it, with apartment buildings in the background.",
        "public_id": "019d08aa-3a2e-7078-a57e-594562c6b6e1",
        "storage_key": "property/6767906449166882/019d08aa-3a2e-7078-a57e-594562c6b6e1.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded seating areas. Enjoy the sunshine and tranquility of this community amenity.",
      "link": "",
      "alt_text": "Community swimming pool with lounge chairs and tables surrounding it, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ff91c04-1ae3-4e20-83e5-1ab9ca12a6b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-3c5f-706a-ab12-90e1d79192a5.webp",
      "image_media": {
        "alt_text": "Secure package lockers for residents",
        "public_id": "019d08aa-3c5f-706a-ab12-90e1d79192a5",
        "storage_key": "property/6767906449166882/019d08aa-3c5f-706a-ab12-90e1d79192a5.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Convenient and secure package lockers available for all residents to receive deliveries safely.",
      "link": "",
      "alt_text": "Secure package lockers for residents",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_18b521d1-d8ad-497a-b9bd-cd26c54919a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-5875-765d-8925-6153ac7168bb.webp",
      "image_media": {
        "alt_text": "Playground with slide and benches next to apartment buildings.",
        "public_id": "019d08aa-5875-765d-8925-6153ac7168bb",
        "storage_key": "property/6767906449166882/019d08aa-5875-765d-8925-6153ac7168bb.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, complete with a slide and ample seating for relaxation.",
      "link": "",
      "alt_text": "Playground with slide and benches next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea42d51c-b6d0-4d3d-b1c7-62e64e602fde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-6396-71ad-b4fd-ab114e29224a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green lawns and mature trees.",
        "public_id": "019d08aa-6396-71ad-b4fd-ab114e29224a",
        "storage_key": "property/6767906449166882/019d08aa-6396-71ad-b4fd-ab114e29224a.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Beautifully manicured grounds surround these apartment buildings, featuring lush green lawns, mature trees, and charming exterior architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with green lawns and mature trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2ad9bd7-4a8f-4af2-bf9f-33e16de6af64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-88f7-7301-8bc6-983a4e9dae76.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with white cabinets and black appliances.",
        "public_id": "019d08aa-88f7-7301-8bc6-983a4e9dae76",
        "storage_key": "property/6767906449166882/019d08aa-88f7-7301-8bc6-983a4e9dae76.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Enjoy meals in the dedicated dining area or cook in the open kitchen, featuring white cabinets and modern black appliances.",
      "link": "",
      "alt_text": "Dining area and kitchen with white cabinets and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_887fdbeb646d95e8022b1b9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Franco's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3320 Data Dr #150, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Low-key restaurant specializing in breakfast, plus burritos, and garlic fries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-6d92-776a-b1b9-654e4f7fcead.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6d92-776a-b1b9-654e4f7fcead",
        "storage_key": "property/6767906449166882/019d08ab-6d92-776a-b1b9-654e4f7fcead.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15521405749687732025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "francos-cafe",
      "poi_latitude": "38.5854473",
      "poi_longitude": "-121.290526",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 916-851-9756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQZ4kD7dmoAROcfXHEscZ9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_4d3a50130da9704ea1c48edc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Cafe Dolce",
      "poi_type": "Restaurants",
      "poi_address": "3140 Gold Camp Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1776140873270173878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-dolce",
      "poi_latitude": "38.5923196",
      "poi_longitude": "-121.2744472",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-476-6027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_SDos0LdmoARtiBSvrYephg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_b697e8f22d23b95ed3a3f2d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Golden Bean Cafe",
      "poi_type": "Restaurants",
      "poi_address": "10860 Gold Center Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Cozy coffeehouse serving breakfast and lunch, including sandwiches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-6d26-77ec-af68-c869d9c2a6e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6d26-77ec-af68-c869d9c2a6e2",
        "storage_key": "property/6767906449166882/019d08ab-6d26-77ec-af68-c869d9c2a6e2.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://the-golden-bean-cafe.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6840609008459443593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-bean-cafe",
      "poi_latitude": "38.5904364",
      "poi_longitude": "-121.2806715",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-635-4491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-197a-701c-acac-8d8c0ec134df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-197a-701c-acac-8d8c0ec134df",
        "storage_key": "property/6767906449166882/019d08ac-197a-701c-acac-8d8c0ec134df.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJHQpG7kHdmoARie2PbKa57l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_0614b1f2e2c4a6f371111c05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Soho Sushi",
      "poi_type": "Restaurants",
      "poi_address": "3101 Zinfandel Dr #122, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Japanese eatery serving sushi, teriyaki, tempura, sake & more in a relaxed, colorful space.",
      "poi_long_description": "Japanese eatery serving sushi, teriyaki, tempura, sake & more in a relaxed, colorful space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-6d25-758a-ac43-c80a15468398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6d25-758a-ac43-c80a15468398",
        "storage_key": "property/6767906449166882/019d08ab-6d25-758a-ac43-c80a15468398.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sohosushirancho.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6267733309511775413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soho-sushi",
      "poi_latitude": "38.5877509",
      "poi_longitude": "-121.2860166",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 916-853-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-U3YbYvlmoARtTRVtDx2-1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_18fe9a8c71825cfd37e32611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Rancho Steve's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "3191 Zinfandel Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Casual pizza joint with gluten-free options and vegan choices available.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-6d05-722e-930a-8402e49757b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6d05-722e-930a-8402e49757b5",
        "storage_key": "property/6767906449166882/019d08ab-6d05-722e-930a-8402e49757b5.webp",
        "width": 760,
        "height": 544
      },
      "poi_business_url": "http://ranchostevepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8709849673857492166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rancho-steves-pizza",
      "poi_latitude": "38.5843904",
      "poi_longitude": "-121.2840585",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-851-0749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr35DhJHdmoARxuRTsSGa33g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_a32efedcdac5dc0d171d41bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Wingstop",
      "poi_type": "Restaurants",
      "poi_address": "3195 Zinfandel Dr Ste 3, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_long_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-75dc-74d8-9d18-21396f14472c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-75dc-74d8-9d18-21396f14472c",
        "storage_key": "property/6767906449166882/019d08ab-75dc-74d8-9d18-21396f14472c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wingstop.com/location/wingstop-390-rancho-cordova-ca-95670/menu?y_source=1_NTUyMDY5NjQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2205935062932485918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wingstop",
      "poi_latitude": "38.5843414",
      "poi_longitude": "-121.2843947",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-635-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXVAJQkfdmoARHnerj0AOnR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5445c714d487dacee00398d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "3199 Zinfandel Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-78d8-766a-9707-c5813ea5ab63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-78d8-766a-9707-c5813ea5ab63",
        "storage_key": "property/6767906449166882/019d08ab-78d8-766a-9707-c5813ea5ab63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations/us/california/rancho-cordova/rancho-cordova?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=17157086953048056067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "38.584149",
      "poi_longitude": "-121.284968",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 916-635-1621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf4wZXEfdmoARAyHrgK43Gu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_79810cde18103c638c20caa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Gyro & Shawarma Grill",
      "poi_type": "Restaurants",
      "poi_address": "2931 Sunrise Blvd STE 100, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "Family-run eatery whipping up classic Greek fare like gyros and kabobs for takeout and dine-in.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-7a5f-74ac-9bdd-579fd91c1b1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7a5f-74ac-9bdd-579fd91c1b1f",
        "storage_key": "property/6767906449166882/019d08ab-7a5f-74ac-9bdd-579fd91c1b1f.webp",
        "width": 1280,
        "height": 320
      },
      "poi_business_url": "https://www.grabull.com/restaurant/gyro-and-shawarma-grill-2931-sunrise-boulevard-rancho-cordova-ca",
      "poi_directions_map_url": "https://maps.google.com/?cid=8400433262512687777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gyro--shawarma-grill",
      "poi_latitude": "38.5971904",
      "poi_longitude": "-121.2648938",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-346-4155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dFNZmDdmoARocpxe4tVlHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_b8cd33c5e2c68747f4c598b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Cantaritos Taqueria and Bar",
      "poi_type": "Restaurants",
      "poi_address": "2931 Sunrise Blvd #120, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "Tacos, enchiladas, and other familiar Mexican standards offered in a casual setting with a full bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-7d6d-736b-9cbe-377cfd6feaa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7d6d-736b-9cbe-377cfd6feaa6",
        "storage_key": "property/6767906449166882/019d08ab-7d6d-736b-9cbe-377cfd6feaa6.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1472176348354879979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cantaritos-taqueria-and-bar",
      "poi_latitude": "38.597116",
      "poi_longitude": "-121.2651177",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-638-0513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDx3bZGDdmoAR66FswpY4bhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_79de0d52d1bfc00c542b8114",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Shahrzad Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2931 Sunrise Blvd #150, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "Eatery with a patio featuring traditional Persian dishes in a charming, homey atmosphere.",
      "poi_long_description": "Eatery with a patio featuring traditional Persian dishes in a charming, homey atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-8061-73e3-b04f-906991dfeb88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8061-73e3-b04f-906991dfeb88",
        "storage_key": "property/6767906449166882/019d08ab-8061-73e3-b04f-906991dfeb88.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://shahrzadrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4995098266439651492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shahrzad-restaurant",
      "poi_latitude": "38.5969511",
      "poi_longitude": "-121.2651412",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-852-8899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE9pr9WDdmoARpBBOfWgnUkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_99390e713e0e04e5662730f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Brookfields Restaurant Rancho Cordova",
      "poi_type": "Restaurants",
      "poi_address": "11135 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Casual, family-run spot supplying breakfast-to-dinner American food, baked goods & take-home meals.",
      "poi_long_description": "Casual, family-run spot supplying breakfast-to-dinner American food, baked goods & take-home meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-8408-763f-a4d2-456c352d70a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8408-763f-a4d2-456c352d70a5",
        "storage_key": "property/6767906449166882/019d08ab-8408-763f-a4d2-456c352d70a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://brookrest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10609532951049233249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookfields-restaurant-rancho-cordova",
      "poi_latitude": "38.6054233",
      "poi_longitude": "-121.2708179",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-638-2046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAeXLG3vdmoARYWMX3AGiPJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_f8b488c99d0d6baafcc141ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Mountain Mike's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "10419 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Casual pizza chain featuring traditional pies, gluten-free crust & assorted appetizers.",
      "poi_long_description": "Casual pizza chain featuring traditional pies, gluten-free crust & assorted appetizers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-83e1-776f-8735-eb2dafed8e16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-83e1-776f-8735-eb2dafed8e16",
        "storage_key": "property/6767906449166882/019d08ab-83e1-776f-8735-eb2dafed8e16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mountainmikespizza.com/locations/rancho-cordova-folsom/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7468455691779216746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-mikes-pizza",
      "poi_latitude": "38.590607",
      "poi_longitude": "-121.300955",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-363-0393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYvSWBndmoARapU-0eFIpWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_88f13933dac637c77fdbc307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "FIESTA PHILIPPINES",
      "poi_type": "Restaurants",
      "poi_address": "11088 Olson Dr A, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Filipino eatery serving crispy pork belly, pancit noodles, seafood options and more, in a relaxed ambience.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-8853-757e-89b6-04289078ef40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8853-757e-89b6-04289078ef40",
        "storage_key": "property/6767906449166882/019d08ab-8853-757e-89b6-04289078ef40.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://myfiestaphilippines.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7102274227856920499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fiesta-philippines",
      "poi_latitude": "38.5981078",
      "poi_longitude": "-121.2804784",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-909-8880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAeTXoQXdmoARs8_S4MdYkGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_3fd7bebf689532c7ec31a256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Pocket Deli",
      "poi_type": "Restaurants",
      "poi_address": "11210 Sun Center Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Counter-service eatery offering pita-pocket sandwiches & beer in an airy, rustic space with TVs.",
      "poi_long_description": "Counter-service eatery offering pita-pocket sandwiches & beer in an airy, rustic space with TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-8d70-73bc-89b0-bc5a906bf2ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8d70-73bc-89b0-bc5a906bf2ef",
        "storage_key": "property/6767906449166882/019d08ab-8d70-73bc-89b0-bc5a906bf2ef.webp",
        "width": 1280,
        "height": 838
      },
      "poi_business_url": "http://www.pocketdeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10514608449522441904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pocket-deli",
      "poi_latitude": "38.5973591",
      "poi_longitude": "-121.266082",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-635-9808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1950-7623-b29d-5c503a844a04",
        "storage_key": "property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw7DrTl7dmoARsB4bEq1k65E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "ec_3fb175db12275e748383aafc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Seoul 1979",
      "poi_type": "Restaurants",
      "poi_address": "3084 Sunrise Blvd #8, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "Casual eatery for Korean street food such as gimbap, hotteok, and cup-bap, plus sushi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-8cde-74ec-b8f6-3e54ad75150d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8cde-74ec-b8f6-3e54ad75150d",
        "storage_key": "property/6767906449166882/019d08ab-8cde-74ec-b8f6-3e54ad75150d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://seoul1979.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12423337172644653754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seoul-1979",
      "poi_latitude": "38.591183",
      "poi_longitude": "-121.2662829",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-476-5512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1987-7713-9c4c-a220864eb635",
        "storage_key": "property/6767906449166882/019d08ac-1987-7713-9c4c-a220864eb635.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX6aEWDjdmoARuupjPFaPaKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_153229964f7dfc3505d6b70c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3301 Zinfandel Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-8c2c-74f1-91ea-fe644c3c6207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8c2c-74f1-91ea-fe644c3c6207",
        "storage_key": "property/6767906449166882/019d08ab-8c2c-74f1-91ea-fe644c3c6207.webp",
        "width": 1280,
        "height": 762
      },
      "poi_business_url": "https://www.cvs.com/store-locator/rancho-cordova-ca-pharmacies/3301-zinfandel-dr-rancho-cordova-ca-95670/storeid=4950?WT.mc_id=LS_GOOGLE_RX_4950",
      "poi_directions_map_url": "https://maps.google.com/?cid=14658795342042924217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.58164230000001",
      "poi_longitude": "-121.2834854",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 916-852-8332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20f4-71ab-8aa7-3907df113bfe",
        "storage_key": "property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXP22kfdmoARuYSerbKAbss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7c9bf935a4fc11699df9665a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10846 Bear Hollow Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-951c-73a8-8a7a-caaf947340fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-951c-73a8-8a7a-caaf947340fd",
        "storage_key": "property/6767906449166882/019d08ab-951c-73a8-8a7a-caaf947340fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sprouts.com//store/ca/rancho-cordova/452-rancho-cordova/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8132213394379632901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "38.577673",
      "poi_longitude": "-121.281827",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 279-278-7553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-2117-7682-8ae4-b9e291351858",
        "storage_key": "property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8-xDandmoARBfGr8f5s23A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_2430b204c4884ac1472b4ede",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "10635 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-94d6-764d-ac81-8f5d1aa59f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-94d6-764d-ac81-8f5d1aa59f65",
        "storage_key": "property/6767906449166882/019d08ab-94d6-764d-ac81-8f5d1aa59f65.webp",
        "width": 744,
        "height": 419
      },
      "poi_business_url": "https://local.safeway.com/safeway/ca/rancho-cordova/10635-folsom-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2079985808272097179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.5953415",
      "poi_longitude": "-121.2933838",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-364-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-2117-7682-8ae4-b9e291351858",
        "storage_key": "property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRtybRHdmoARm3_phxKY3Rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_827a2125f4fcdc112c1b8db2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "10655 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Department-store chain offering electronics, appliances, apparel, housewares, groceries, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-9588-75b0-b62f-12cf7a6fdb2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9588-75b0-b62f-12cf7a6fdb2e",
        "storage_key": "property/6767906449166882/019d08ab-9588-75b0-b62f-12cf7a6fdb2e.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2457-rancho-cordova-ca/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17235070028126597454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.5959836",
      "poi_longitude": "-121.2917657",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-361-0296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1950-7623-b29d-5c503a844a04",
        "storage_key": "property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuzWjfBHdmoARTrF3EeBEL-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_28940ad378cf4055e0ac4424",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10881 Olson Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-9630-72ae-b490-d1d12f88d559.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9630-72ae-b490-d1d12f88d559",
        "storage_key": "property/6767906449166882/019d08ab-9630-72ae-b490-d1d12f88d559.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/rancho-cordova/2463",
      "poi_directions_map_url": "https://maps.google.com/?cid=5766025245138693999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.5968366",
      "poi_longitude": "-121.2859092",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-503-2512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1950-7623-b29d-5c503a844a04",
        "storage_key": "property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK2lPymzdmoARby9tJmkJBVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_0c7ff485af5155bcae4dd6da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "KP International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10971 Olson Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Large grocery with a food court selling a wide selection of international products.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-9c16-7146-af44-a281634f65c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9c16-7146-af44-a281634f65c1",
        "storage_key": "property/6767906449166882/019d08ab-9c16-7146-af44-a281634f65c1.webp",
        "width": 754,
        "height": 378
      },
      "poi_business_url": "https://sac.kpmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15187449826825008127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kp-international-market",
      "poi_latitude": "38.596949",
      "poi_longitude": "-121.2834325",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-853-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-2117-7682-8ae4-b9e291351858",
        "storage_key": "property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53wh7GzdmoAR__P4oyapxNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_9a10cc57c6aac55456b85dff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Viva Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10385 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Clean, compact store stocking a variety of fresh produce and groceries, with a deli, bakery and food court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-9d30-766d-a12f-a862a12ea02c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9d30-766d-a12f-a862a12ea02c",
        "storage_key": "property/6767906449166882/019d08ab-9d30-766d-a12f-a862a12ea02c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vivasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1583568185623207790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "viva-supermarket",
      "poi_latitude": "38.589954",
      "poi_longitude": "-121.3040397",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-476-4243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-2117-7682-8ae4-b9e291351858",
        "storage_key": "property/6767906449166882/019d08ac-2117-7682-8ae4-b9e291351858.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8H4FxzdmoARbl-u7d_2-RU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_3b6b941a1e4ae116da02996e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "10337 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-9d0a-7319-8e43-87dac7fca2b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9d0a-7319-8e43-87dac7fca2b3",
        "storage_key": "property/6767906449166882/019d08ab-9d0a-7319-8e43-87dac7fca2b3.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "http://www.dollartree.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10265785957838611406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "38.5884782",
      "poi_longitude": "-121.3067909",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 279-221-7975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1950-7623-b29d-5c503a844a04",
        "storage_key": "property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe21dGADdmoARzuMpLfBld44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_b6c08f05e8524bb92dd08b10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "dd's DISCOUNTS",
      "poi_type": "Shopping & Retail",
      "poi_address": "10347 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Retail chain stocking discounted clothing & shoes for adults or kids, plus home decor.",
      "poi_long_description": "Retail chain stocking discounted clothing & shoes for adults or kids, plus home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-9dc7-70ae-bed4-a7a0557fa6cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9dc7-70ae-bed4-a7a0557fa6cd",
        "storage_key": "property/6767906449166882/019d08ab-9dc7-70ae-bed4-a7a0557fa6cd.webp",
        "width": 1196,
        "height": 673
      },
      "poi_business_url": "https://www.ddsdiscounts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8005094834753676009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dds-discounts",
      "poi_latitude": "38.5890798",
      "poi_longitude": "-121.3062532",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-368-7909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1950-7623-b29d-5c503a844a04",
        "storage_key": "property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ9l40B3dmoAR6aLO4lbPF28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_e64d6583dfc57732bb8e1989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "3251 Zinfandel Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-a2b5-71d7-b23b-e551825c233d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a2b5-71d7-b23b-e551825c233d",
        "storage_key": "property/6767906449166882/019d08ab-a2b5-71d7-b23b-e551825c233d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/CA-Rancho-Cordova/2341?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2341-_-na-_-0-_-0&y_source=1_MTE4NDM4OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16234715863256754392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "38.583673",
      "poi_longitude": "-121.282728",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-267-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1950-7623-b29d-5c503a844a04",
        "storage_key": "property/6767906449166882/019d08ac-1950-7623-b29d-5c503a844a04.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyZH7qEfdmoAR2GjR-g9MTeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_00b275b5f5b22d78174e47ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Cordova Villa Elementary School",
      "poi_type": "Education",
      "poi_address": "10359 S White Rock Rd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://cve.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2345720547907354565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cordova-villa-elementary-school",
      "poi_latitude": "38.579525",
      "poi_longitude": "-121.299028",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 916-294-9125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB0726STdmoARxT9aAGmsjSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9fae29d3badfc9c5c7f4dd79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "White Rock Elementary School",
      "poi_type": "Education",
      "poi_address": "10487 White Rock Rd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-a380-7492-9036-0ec7a05f6160.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a380-7492-9036-0ec7a05f6160",
        "storage_key": "property/6767906449166882/019d08ab-a380-7492-9036-0ec7a05f6160.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://wre.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18175600795408241634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-rock-elementary-school",
      "poi_latitude": "38.5867382",
      "poi_longitude": "-121.2997737",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-294-9180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0YKEYRjdmoAR4pOd_Z-0PPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5308f3d7cda8d6a713c7c5d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Navigator Elementary School",
      "poi_type": "Education",
      "poi_address": "10679 Bear Hollow Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nve.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10438217960889507232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "navigator-elementary-school",
      "poi_latitude": "38.573245",
      "poi_longitude": "-121.285234",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-294-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9Zf3jkrdmoARoN3rbu7_25A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_82eaed4b96396e764c79fd71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Mills Middle School",
      "poi_type": "Education",
      "poi_address": "10439 Coloma Rd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-a4aa-734b-895e-24d3ce2895cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a4aa-734b-895e-24d3ce2895cc",
        "storage_key": "property/6767906449166882/019d08ab-a4aa-734b-895e-24d3ce2895cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mms.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3173983757833007394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mills-middle-school",
      "poi_latitude": "38.599022",
      "poi_longitude": "-121.303459",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-294-9045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4100ZwHdmoARIvF-SGlBDCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_60b171526b00475313848041",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Cordova High School",
      "poi_type": "Education",
      "poi_address": "2239 Chase Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-a4aa-734b-895e-2ab014fcc1c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a4aa-734b-895e-2ab014fcc1c3",
        "storage_key": "property/6767906449166882/019d08ab-a4aa-734b-895e-2ab014fcc1c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://chs.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5492938749196075309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cordova-high-school",
      "poi_latitude": "38.5997963",
      "poi_longitude": "-121.3078153",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-294-2450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0J_0gHdmoARLYHPhrDWOkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_873626c81102648008b423ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Rancho Cordova Elementary School",
      "poi_type": "Education",
      "poi_address": "2562 Chassella Way, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://rce.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13241282456780495730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rancho-cordova-elementary-school",
      "poi_latitude": "38.5999393",
      "poi_longitude": "-121.2959652",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-294-9165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLZ9xAg_dmoARclsDNz18wrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_50e6487b72d9032bae302297",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Cordova Meadows Elementary School",
      "poi_type": "Education",
      "poi_address": "2550 La Loma Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-a8dc-7447-bb66-335ac24e2cd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8dc-7447-bb66-335ac24e2cd2",
        "storage_key": "property/6767906449166882/019d08ab-a8dc-7447-bb66-335ac24e2cd2.webp",
        "width": 400,
        "height": 300
      },
      "poi_business_url": "http://cme.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11238992034167980855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cordova-meadows-elementary-school",
      "poi_latitude": "38.58946299999999",
      "poi_longitude": "-121.3160004",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-294-9120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUwI_uOTcmoARNwMHVrXr-Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_2574ed53a70b8ea14f6de441",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Riverview STEM Academy",
      "poi_type": "Education",
      "poi_address": "10700 Ambassador Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rsa.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10717090475858237610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-stem-academy",
      "poi_latitude": "38.6164667",
      "poi_longitude": "-121.2931371",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-294-2435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIV4_1rrdmoARqphAlwHBupQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_caf017f8e9f6af87d8a8be67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Peter J Shields Elementary",
      "poi_type": "Education",
      "poi_address": "10434 Georgetown Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pjse.fcusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3059612709911689556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peter-j-shields-elementary",
      "poi_latitude": "38.6070556",
      "poi_longitude": "-121.3007965",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-294-9160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoUkJg6ndmoARVHmOlIztdSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_64cca12ccb8bbff4e0fd2aa0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "American River College",
      "poi_type": "Education",
      "poi_address": "4700 College Oak Dr, Sacramento, CA 95841, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-aab0-7796-abd1-d9f2f54f2893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-aab0-7796-abd1-d9f2f54f2893",
        "storage_key": "property/6767906449166882/019d08ab-aab0-7796-abd1-d9f2f54f2893.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "https://arc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1010375658575580987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-river-college",
      "poi_latitude": "38.6511479",
      "poi_longitude": "-121.3467327",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 916-484-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS44sh8nemoARO08Z606TBQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_cbb0be80421af9390904c9f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sacramento Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "2701 Prospect Park Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Open since 2011, a museum for kids aged 8 and under which runs interactive events & activities.",
      "poi_long_description": "Open since 2011, a museum for kids aged 8 and under which runs interactive events & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-ab43-7348-ab97-dabc6412caa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ab43-7348-ab97-dabc6412caa1",
        "storage_key": "property/6767906449166882/019d08ab-ab43-7348-ab97-dabc6412caa1.webp",
        "width": 1280,
        "height": 984
      },
      "poi_business_url": "http://www.sackids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15104424772155538293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacramento-childrens-museum",
      "poi_latitude": "38.5888889",
      "poi_longitude": "-121.2838889",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-730-5079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-210c-715d-8db0-0f38590353cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-210c-715d-8db0-0f38590353cd",
        "storage_key": "property/6767906449166882/019d08ac-210c-715d-8db0-0f38590353cd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WM0IQPamoARdfvwuE2yndE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_cc3a37e616a3eaf66cb8a06b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "West Wind Sacramento 6 Drive-In",
      "poi_type": "Entertainment",
      "poi_address": "9616 Oates Dr, Sacramento, CA 95827, USA",
      "poi_short_description": "This retro drive-in movie theater screens the latest releases & pipes sound into cars via FM radio.",
      "poi_long_description": "This retro drive-in movie theater screens the latest releases & pipes sound into cars via FM radio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-ac90-7698-87bf-3d15303f1bfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ac90-7698-87bf-3d15303f1bfe",
        "storage_key": "property/6767906449166882/019d08ab-ac90-7698-87bf-3d15303f1bfe.webp",
        "width": 1280,
        "height": 841
      },
      "poi_business_url": "https://www.westwinddi.com/locations/sacramento",
      "poi_directions_map_url": "https://maps.google.com/?cid=9853029322443566582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-wind-sacramento-6-drive-in",
      "poi_latitude": "38.5663217",
      "poi_longitude": "-121.3394999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-484-4168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-274c-774e-980d-3ea30f2d7e26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-274c-774e-980d-3ea30f2d7e26",
        "storage_key": "property/6767906449166882/019d08ac-274c-774e-980d-3ea30f2d7e26.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bG-ULrcmoAR9q3BFff9vIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_b9c93a822870dc3e2be36893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sac Laser Tag",
      "poi_type": "Entertainment",
      "poi_address": "9823 Old Winery Pl, Sacramento, CA 95827, USA",
      "poi_short_description": "Fun, kid-friendly, 2-level laser tag arena also featuring arcades and bumper cars.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-af5e-7631-a585-490436124f09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-af5e-7631-a585-490436124f09",
        "storage_key": "property/6767906449166882/019d08ab-af5e-7631-a585-490436124f09.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://saclasertag.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10129016657011205247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sac-laser-tag",
      "poi_latitude": "38.5748658",
      "poi_longitude": "-121.3299569",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-382-9905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98ebnRvdmoARf-Qq1ft-kYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_bcb77b8b09d618d7f854aaee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "K1 Speed - Indoor Go Karts, Corporate Event Venue, Team Building Activities",
      "poi_type": "Entertainment",
      "poi_address": "3130 Bradshaw Rd, Sacramento, CA 95827, USA",
      "poi_short_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_long_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-b18a-77be-8c80-bfd8ee9a1ab2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b18a-77be-8c80-bfd8ee9a1ab2",
        "storage_key": "property/6767906449166882/019d08ab-b18a-77be-8c80-bfd8ee9a1ab2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://k1speed.com/sacramento-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=18088301146301519307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k1-speed---indoor-go-karts-corporate-event-venue-team-building-activities",
      "poi_latitude": "38.56887529999999",
      "poi_longitude": "-121.3376427",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-368-7223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9NwYbncmoARy9WXfw6OBvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_554dcfd117454b25feddb02e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Rebounderz Sacramento - Indoor Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2401 Butano Dr, Sacramento, CA 95825, USA",
      "poi_short_description": "Trampoline park with climbing walls, arcade games and a ninja course, plus free WiFi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-b185-71aa-b817-8a09f8a05f1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b185-71aa-b817-8a09f8a05f1d",
        "storage_key": "property/6767906449166882/019d08ab-b185-71aa-b817-8a09f8a05f1d.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.rebounderz.com/city/sacramento/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13746415684359926292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rebounderz-sacramento---indoor-trampoline-and-adventure-park",
      "poi_latitude": "38.6078872",
      "poi_longitude": "-121.3804779",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-829-8969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadAv-MXbmoARFLIhuTsUxb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_35b51651181a5f69d2cbc53e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Dream Arcades Inc.",
      "poi_type": "Entertainment",
      "poi_address": "11415 Sunrise Gold Cir STE 9, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-b280-7238-a73c-344f4eadc3c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b280-7238-a73c-344f4eadc3c0",
        "storage_key": "property/6767906449166882/019d08ab-b280-7238-a73c-344f4eadc3c0.webp",
        "width": 1280,
        "height": 1190
      },
      "poi_business_url": "http://www.dreamarcades.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14591561085034764781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dream-arcades-inc",
      "poi_latitude": "38.5971926",
      "poi_longitude": "-121.2596683",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-545-8625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3dFtornmoAR7RnpV3-jf8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_09ed32cabd0e104a5e334030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "California State Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "125 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "Colorful museum documenting railroad history via vintage locomotives, exhibits & rides.",
      "poi_long_description": "Colorful museum documenting railroad history via vintage locomotives, exhibits & rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-b784-76bc-9b4c-813a86c482b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b784-76bc-9b4c-813a86c482b4",
        "storage_key": "property/6767906449166882/019d08ab-b784-76bc-9b4c-813a86c482b4.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.californiarailroad.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13064911033240821480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "california-state-railroad-museum",
      "poi_latitude": "38.5849368",
      "poi_longitude": "-121.5044161",
      "poi_miles_from_property": "13.8 mi",
      "poi_walking_minutes": "5 hours 4 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 916-323-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-210c-715d-8db0-0f38590353cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-210c-715d-8db0-0f38590353cd",
        "storage_key": "property/6767906449166882/019d08ac-210c-715d-8db0-0f38590353cd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxCsn83WmoAR6J5mJl3jT7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_1cd299a5de260b9c4bc12656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Harlow's",
      "poi_type": "Entertainment",
      "poi_address": "2708 J St, Sacramento, CA 95816, USA",
      "poi_short_description": "Dinner with live blues, soul & rock ‘n’ roll shows in a casual setting with VIP booths & a patio.",
      "poi_long_description": "Dinner with live blues, soul & rock ‘n’ roll shows in a casual setting with VIP booths & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-b964-702b-b282-610d5f98a707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b964-702b-b282-610d5f98a707",
        "storage_key": "property/6767906449166882/019d08ab-b964-702b-b282-610d5f98a707.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.harlows.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18366415798788494997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harlows",
      "poi_latitude": "38.5738772",
      "poi_longitude": "-121.4701937",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-441-4693",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_DBPMDQmoARlRbpC9yd4v4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_a2289ae4547ce512195a19a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Cinemark Century Folsom 14",
      "poi_type": "Entertainment",
      "poi_address": "261 Iron Point Rd, Folsom, CA 95630, USA",
      "poi_short_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_long_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-b964-702b-b282-6b535a16f821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b964-702b-b282-6b535a16f821",
        "storage_key": "property/6767906449166882/019d08ab-b964-702b-b282-6b535a16f821.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ca-folsom/cinemark-century-folsom-14?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5OTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8509714882693168514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-century-folsom-14",
      "poi_latitude": "38.6414499",
      "poi_longitude": "-121.1914116",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-353-5247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-274c-774e-980d-3ea30f2d7e26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-274c-774e-980d-3ea30f2d7e26",
        "storage_key": "property/6767906449166882/019d08ac-274c-774e-980d-3ea30f2d7e26.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRfTf4vmmoARgv3HcpmUGHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ce1bc7f9b78684af18bb035e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sactown Family Fun Mini Golf And Arcade",
      "poi_type": "Entertainment",
      "poi_address": "12401 Folsom Blvd #105, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "Black-lit mini golf spot featuring 18-hole courses with themes like pirates and mermaids, plus an arcade.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-bbe3-764f-a3b3-363c0c3f85b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-bbe3-764f-a3b3-363c0c3f85b1",
        "storage_key": "property/6767906449166882/019d08ab-bbe3-764f-a3b3-363c0c3f85b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sactownfamilyfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1434454404787869116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sactown-family-fun-mini-golf-and-arcade",
      "poi_latitude": "38.6297776",
      "poi_longitude": "-121.2148827",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-790-8448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fNKBlfnmoARvBXgW6406BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_d7943ac60b2bf87d815f5d7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sacramento VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10535 Hospital Way, Mather, CA 95655, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-c002-74bc-989b-19bb936b0e72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c002-74bc-989b-19bb936b0e72",
        "storage_key": "property/6767906449166882/019d08ab-c002-74bc-989b-19bb936b0e72.webp",
        "width": 480,
        "height": 320
      },
      "poi_business_url": "https://www.va.gov/northern-california-health-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671437030510185164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacramento-va-medical-center",
      "poi_latitude": "38.5725922",
      "poi_longitude": "-121.2966576",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-382-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27ad-77c2-b8a0-b31ea0a2beba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27ad-77c2-b8a0-b31ea0a2beba",
        "storage_key": "property/6767906449166882/019d08ac-27ad-77c2-b8a0-b31ea0a2beba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83XUHDLdmoARzEpiS9PZEiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1b538788b6be15769ed529e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "UC Davis Health Rancho Cordova Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3201 Data Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-c0a1-76cc-baf5-02bb13c5809d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c0a1-76cc-baf5-02bb13c5809d",
        "storage_key": "property/6767906449166882/019d08ab-c0a1-76cc-baf5-02bb13c5809d.webp",
        "width": 754,
        "height": 600
      },
      "poi_business_url": "https://health.ucdavis.edu/patients-visitors/locations/primary-care/rancho-cordova-3201-data-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=12206016839375209908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uc-davis-health-rancho-cordova-clinic",
      "poi_latitude": "38.5853797",
      "poi_longitude": "-121.2837812",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 916-851-1440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1fh0kGvdmoARtEVlKaV7ZKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_3131ac631a69b3614af654aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Mercy San Juan Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6501 Coyle Ave, Carmichael, CA 95608, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-c162-7741-bc96-5f8334c41778.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c162-7741-bc96-5f8334c41778",
        "storage_key": "property/6767906449166882/019d08ab-c162-7741-bc96-5f8334c41778.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dignityhealth.org/mercy-san-juan-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=323581014851310780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-san-juan-medical-center",
      "poi_latitude": "38.6696173",
      "poi_longitude": "-121.3140834",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 916-537-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27b0-704e-ae78-ac68e1242700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27b0-704e-ae78-ac68e1242700",
        "storage_key": "property/6767906449166882/019d08ac-27b0-704e-ae78-ac68e1242700.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbHHnfnemoARvNRF9jeXfQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b85352487f46c1c21d251fd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3301 Zinfandel Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-8c2c-74f1-91ea-fe644c3c6207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8c2c-74f1-91ea-fe644c3c6207",
        "storage_key": "property/6767906449166882/019d08ab-8c2c-74f1-91ea-fe644c3c6207.webp",
        "width": 1280,
        "height": 762
      },
      "poi_business_url": "https://www.cvs.com/store-locator/rancho-cordova-ca-pharmacies/3301-zinfandel-dr-rancho-cordova-ca-95670/storeid=4950?WT.mc_id=LS_GOOGLE_RX_4950",
      "poi_directions_map_url": "https://maps.google.com/?cid=14658795342042924217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.58164230000001",
      "poi_longitude": "-121.2834854",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 916-852-8332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20f4-71ab-8aa7-3907df113bfe",
        "storage_key": "property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXP22kfdmoARuYSerbKAbss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_ed825cc528dab7a7ea6fe4f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4050 Sunrise Blvd, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-c453-746e-be86-9c095a57213e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c453-746e-be86-9c095a57213e",
        "storage_key": "property/6767906449166882/019d08ab-c453-746e-be86-9c095a57213e.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4050+sunrise+blvd-rancho+cordova-ca-95742/id=9532",
      "poi_directions_map_url": "https://maps.google.com/?cid=2518459978741217919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.555901",
      "poi_longitude": "-121.2435077",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-294-9566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20f4-71ab-8aa7-3907df113bfe",
        "storage_key": "property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyq4xjnomoARf3ro3QFe8yI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_696c8e0fee999e4201578644",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10655 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-cada-774c-a6db-bb8f2d3c1c9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cada-774c-a6db-bb8f2d3c1c9f",
        "storage_key": "property/6767906449166882/019d08ab-cada-774c-a6db-bb8f2d3c1c9f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/2457-rancho-cordova-ca/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7705765311846689091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "38.5959836",
      "poi_longitude": "-121.2917657",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-361-0515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20f4-71ab-8aa7-3907df113bfe",
        "storage_key": "property/6767906449166882/019d08ac-20f4-71ab-8aa7-3907df113bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xjbkRHdmoARQykmZ7lg8Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f76f234d8a6e1ce7f8b008a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1975 Zinfandel Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Chain gym offering a pool, sauna, racquetball, and Pilates and yoga studios, plus child care.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-cc1f-71e9-bfd8-7e3039826633.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cc1f-71e9-bfd8-7e3039826633",
        "storage_key": "property/6767906449166882/019d08ab-cc1f-71e9-bfd8-7e3039826633.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.inshape.com/gyms/sunrise-hwy-50?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6054210992364909361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.6126999",
      "poi_longitude": "-121.2707469",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-631-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXRiBiHjdmoARMfMsK9LgBFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a9f2b48076fdf9cad28b8dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10373 Folsom Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Casual fitness center, which is open 24/7, with tanning booths, massage chairs, clean equipment and free weights.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-cce3-779c-a20b-c1f8ea0ad5cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cce3-779c-a20b-c1f8ea0ad5cd",
        "storage_key": "property/6767906449166882/019d08ab-cce3-779c-a20b-c1f8ea0ad5cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/rancho-cordova-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16551129859534872860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.589464",
      "poi_longitude": "-121.305273",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-368-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-0ylx7dmoARHOHvZOpsseU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_e473de88e707f389b749dbf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sattva California",
      "poi_type": "Health and Wellness",
      "poi_address": "3195 Zinfandel Dr Suite 23, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-cce3-779c-a20b-be0674740117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cce3-779c-a20b-be0674740117",
        "storage_key": "property/6767906449166882/019d08ab-cce3-779c-a20b-be0674740117.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://sattvacali.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15959729305054460520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sattva-california",
      "poi_latitude": "38.5843351",
      "poi_longitude": "-121.2843404",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-246-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgX2DhE_dmoARaLopoz5ZfN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_1d5053a55102342fef7fea52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Pilates Heartcore",
      "poi_type": "Health and Wellness",
      "poi_address": "2951 Sunrise Blvd #115, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-d88b-7418-9f9b-fc275a13c2dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d88b-7418-9f9b-fc275a13c2dd",
        "storage_key": "property/6767906449166882/019d08ab-d88b-7418-9f9b-fc275a13c2dd.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://getheartcore.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6153285697933330942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-heartcore",
      "poi_latitude": "38.5967957",
      "poi_longitude": "-121.2644023",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-597-0717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBV5aQ1bomoAR_snOor3cZFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_c205abd53acff22678ed3283",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "River Bend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 Rod Beaudry Dr, Sacramento, CA 95827, USA",
      "poi_short_description": "444-acre riverfront park features rafting, equestrian & hiking trails, picnicking space & wildlife.",
      "poi_long_description": "444-acre riverfront park features rafting, equestrian & hiking trails, picnicking space & wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-d64c-71a2-a1cf-701a09b33c0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d64c-71a2-a1cf-701a09b33c0b",
        "storage_key": "property/6767906449166882/019d08ab-d64c-71a2-a1cf-701a09b33c0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.regionalparks.saccounty.net/Parks/Pages/RiverBendPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13299131916403720630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-bend-park",
      "poi_latitude": "38.5952521",
      "poi_longitude": "-121.3302371",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjbDmoARtsFNIgQCkLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_61b141ef8321fc1749a958d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "White Rock Neighborhood Splash Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10488 White Rock Rd A, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Playful water park featuring 2 slides, a bucket and other features, plus a clean playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-d669-75c8-8d10-889c24245cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d669-75c8-8d10-889c24245cb7",
        "storage_key": "property/6767906449166882/019d08ab-d669-75c8-8d10-889c24245cb7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cordovarpd.gov/parks/white-rock-splash-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4696759076083854131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-rock-neighborhood-splash-park",
      "poi_latitude": "38.5852927",
      "poi_longitude": "-121.3002919",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeR-oeyLdmoARM-uRxX49LkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_1874c9f1b16c4ab7cd70c490",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "The Village Green",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3141 Bridgeway Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Family-friendly spray park with free summer concerts, movies and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-d698-7654-8480-80e95adad9f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d698-7654-8480-80e95adad9f4",
        "storage_key": "property/6767906449166882/019d08ab-d698-7654-8480-80e95adad9f4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://crpd.com/parks/village-green-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18163332666330345996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-village-green",
      "poi_latitude": "38.584765",
      "poi_longitude": "-121.280697",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-369-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7U9ojkbdmoARDHLemdMeEfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_246060b034ab64c41c5d2f00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Mather Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4111 Old Eagle's Nest Road, Mather, CA 95655, USA",
      "poi_short_description": "Large park with playgrounds, picnic areas and a lake, plus barbecue pits.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-dedf-7450-a863-4de58b8fefef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-dedf-7450-a863-4de58b8fefef",
        "storage_key": "property/6767906449166882/019d08ab-dedf-7450-a863-4de58b8fefef.webp",
        "width": 1280,
        "height": 869
      },
      "poi_business_url": "http://www.regionalparks.saccounty.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5557787988310740478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mather-regional-park",
      "poi_latitude": "38.5569758",
      "poi_longitude": "-121.2595373",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbKBxynomoAR_s0xnLo6IU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d4f3dff1e3d1c58a7f17999c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Rossmoor Bar River Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1903-1901 Rossmoor Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-dfdc-76ee-8810-ddd517e3c4a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-dfdc-76ee-8810-ddd517e3c4a6",
        "storage_key": "property/6767906449166882/019d08ab-dfdc-76ee-8810-ddd517e3c4a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://regionalparks.saccounty.net/Parks/Pages/RossmoorBar.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13256863086677631621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rossmoor-bar-river-access",
      "poi_latitude": "38.6242215",
      "poi_longitude": "-121.3016339",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2AOjTvdmoARhaJoTb3W-bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6470d5eca3b04db3a4d4191b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sunrise Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S Bridge St, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Waterfront stretch offering scenic hiking, biking & equestrian trails, river rafting & BBQ grills.",
      "poi_long_description": "Waterfront stretch offering scenic hiking, biking & equestrian trails, river rafting & BBQ grills.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-df58-716d-9d9c-71108fc8bf1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-df58-716d-9d9c-71108fc8bf1b",
        "storage_key": "property/6767906449166882/019d08ab-df58-716d-9d9c-71108fc8bf1b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.regionalparks.saccounty.net/Parks/Pages/SunriseRecAreasUpperandLower.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17409916045946417349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunrise-recreation-area",
      "poi_latitude": "38.62960289999999",
      "poi_longitude": "-121.2717461",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeJFJJLdmoARxXAC8GZynPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0f2d56d4b9ad7b5a1c426d33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sunriver Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11120 Moose River Ct, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Green space featuring playgrounds, picnic tables, basketball and river access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-e169-763d-b589-135312491b2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e169-763d-b589-135312491b2c",
        "storage_key": "property/6767906449166882/019d08ab-e169-763d-b589-135312491b2c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://crpd.com/parks/sunriver-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16759638750390480051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunriver-park",
      "poi_latitude": "38.6248706",
      "poi_longitude": "-121.272472",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-369-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-jjSo7dmoARs2zlqKUylug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_339097c4f3cd6974d4aeec78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Dave Roberts Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10820 Mapola Way, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Popular park featuring a playground, tennis courts and a soccer field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-eb25-76f3-b703-b62d5bd951cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-eb25-76f3-b703-b62d5bd951cb",
        "storage_key": "property/6767906449166882/019d08ab-eb25-76f3-b703-b62d5bd951cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crpd.com/parks/dave-roberts-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8847379956727600962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave-roberts-community-park",
      "poi_latitude": "38.611588",
      "poi_longitude": "-121.280871",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-369-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbyCfEp7dmoARQteo-TE1yHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_459bdfbc0188610223eeab59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Hagan Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2197 Chase Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Large green space with lots of amenities, including athletic fields, an aquatic center & a dog park.",
      "poi_long_description": "Large green space with lots of amenities, including athletic fields, an aquatic center & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-e9a6-72ea-bd17-6cd8abb2314f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e9a6-72ea-bd17-6cd8abb2314f",
        "storage_key": "property/6767906449166882/019d08ab-e9a6-72ea-bd17-6cd8abb2314f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crpd.com/parks/hagan-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13509648951063243279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagan-community-park",
      "poi_latitude": "38.6047426",
      "poi_longitude": "-121.3103096",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-369-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97R8XFXcmoARD2pa0CTqe7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_efbbd4780e78b24e717e5dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "El Manto River Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2000 El Manto Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Riverside area for hiking, swimming, fishing and cycling amidst trees and rocks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-e9a8-75b2-af76-591d34400ce5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e9a8-75b2-af76-591d34400ce5",
        "storage_key": "property/6767906449166882/019d08ab-e9a8-75b2-af76-591d34400ce5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://regionalparks.saccounty.gov/Parks/Pages/RossmoorBar.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10742066193777146057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-manto-river-access",
      "poi_latitude": "38.6249008",
      "poi_longitude": "-121.2925806",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27f1-7109-b9dc-0638e43701a9",
        "storage_key": "property/6767906449166882/019d08ac-27f1-7109-b9dc-0638e43701a9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJacZAvrjdmoARybjREUp8E5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ee4894545396804db8ec12cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Zinfandel Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-eb0d-73d6-9643-3893620cf91e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-eb0d-73d6-9643-3893620cf91e",
        "storage_key": "property/6767906449166882/019d08ab-eb0d-73d6-9643-3893620cf91e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=444754424492503502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zinfandel-station-eb",
      "poi_latitude": "38.595294",
      "poi_longitude": "-121.289773",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_v5txPdmoARzrEo7MoVLAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_8ce84681ac006cc1c6c58d7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Cordova Town Center Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-f4a6-724e-a256-5f2d1555740b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f4a6-724e-a256-5f2d1555740b",
        "storage_key": "property/6767906449166882/019d08ab-f4a6-724e-a256-5f2d1555740b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6416480406257902131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cordova-town-center-station-wb",
      "poi_latitude": "38.598441",
      "poi_longitude": "-121.283655",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZEhEW3dmoARM6JB--7qC1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_736c3b2a2446db97fe5bb073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sunrise Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-f493-76fb-97f6-7be9c2cbc718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f493-76fb-97f6-7be9c2cbc718",
        "storage_key": "property/6767906449166882/019d08ab-f493-76fb-97f6-7be9c2cbc718.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8603982909584208959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunrise-station-eb",
      "poi_latitude": "38.606965",
      "poi_longitude": "-121.266108",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0M-5XzdmoARP3RM0958Z3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_be105268245f3578cc74a119",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Mather Field/Mills Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-f5ab-73f9-b928-5a98b543103e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f5ab-73f9-b928-5a98b543103e",
        "storage_key": "property/6767906449166882/019d08ab-f5ab-73f9-b928-5a98b543103e.webp",
        "width": 1280,
        "height": 1114
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13234103057144582232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mather-fieldmills-station-wb",
      "poi_latitude": "38.584483",
      "poi_longitude": "-121.311617",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4eB_uDcmoARWJAD-pz6qLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_ff106783cd92eaf07e251072",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Chesapeake Commons Apartments",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Data Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-f5ab-73f9-b928-5d6d10777dfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f5ab-73f9-b928-5d6d10777dfa",
        "storage_key": "property/6767906449166882/019d08ab-f5ab-73f9-b928-5d6d10777dfa.webp",
        "width": 612,
        "height": 408
      },
      "poi_business_url": "https://www.chesapeakecommonsisyourhome.com/?rcstdid=Mg==-YRjTEizZPgM=&utm_source=GMB&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11045902552577177171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesapeake-commons-apartments",
      "poi_latitude": "38.5774871",
      "poi_longitude": "-121.2965366",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 916-659-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRz9AKTDdmoARU3bxDdntSpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_00852cfd6370c5c07eb46fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "White Rock Rd & Zinfandel Dr (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13064946440109890955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-rock-rd--zinfandel-dr-eb",
      "poi_latitude": "38.58791",
      "poi_longitude": "-121.28585",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCaqrhT_dmoARix1B9JADULU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_7ea5274ab3e1d6e9ec448d71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Zinfandel Dr & Data Dr (SB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9075278583261752260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zinfandel-dr--data-dr-sb",
      "poi_latitude": "38.58501",
      "poi_longitude": "-121.2861",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaAZrTjdmoARxOsG4cnd8X0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_3b62d10559411eff2c8133d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Butterfield Light Rail Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9646 Butterfield Way, Sacramento, CA 95827, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-fe11-711e-9553-fd1e219fd775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fe11-711e-9553-fd1e219fd775",
        "storage_key": "property/6767906449166882/019d08ab-fe11-711e-9553-fd1e219fd775.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9545335654806028447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "butterfield-light-rail-station-park--ride",
      "poi_latitude": "38.5671584",
      "poi_longitude": "-121.3451039",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-321-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-2e8f-7189-a2af-be9fa1abc132.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-2e8f-7189-a2af-be9fa1abc132",
        "storage_key": "property/6767906449166882/019d08ac-2e8f-7189-a2af-be9fa1abc132.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-Imr6TcmoARn4CVZjTYd4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "ec_80617c26c096a278bce3aa7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sacramento International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6900 Airport Blvd, Sacramento, CA 95837, USA",
      "poi_short_description": "This airport serving Northern California is decorated with a variety of modern artworks.",
      "poi_long_description": "This airport serving Northern California is decorated with a variety of modern artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-fe58-7696-827b-62fdcd0095d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fe58-7696-827b-62fdcd0095d1",
        "storage_key": "property/6767906449166882/019d08ab-fe58-7696-827b-62fdcd0095d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.smf.aero/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11844625427654984242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacramento-international-airport",
      "poi_latitude": "38.694402",
      "poi_longitude": "-121.5888116",
      "poi_miles_from_property": "23.7 mi",
      "poi_walking_minutes": "8 hours 42 mins",
      "poi_biking_minutes": "2 hours 21 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 916-929-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-2e92-72af-bf7c-2b47852ded4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-2e92-72af-bf7c-2b47852ded4c",
        "storage_key": "property/6767906449166882/019d08ac-2e92-72af-bf7c-2b47852ded4c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJrXBqznMrm4ARMkLvKBKQYKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_e07efb3e98f4c7177b7a78b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Aerojet Rocketdyne",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2001 Aerojet Road Rancho, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-fed4-773f-964e-6486d7b88a31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fed4-773f-964e-6486d7b88a31",
        "storage_key": "property/6767906449166882/019d08ab-fed4-773f-964e-6486d7b88a31.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.l3harris.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1643566015800845975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aerojet-rocketdyne",
      "poi_latitude": "38.6277633",
      "poi_longitude": "-121.2052798",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-355-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOxvaEMJK3YARl6a2WJUezxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_1000e80b30a2fbde7d474ced",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Centene Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10730 International Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-ffa1-709a-b407-77c849d470e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ffa1-709a-b407-77c849d470e9",
        "storage_key": "property/6767906449166882/019d08ab-ffa1-709a-b407-77c849d470e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.centene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14104795479016112617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centene-corporation",
      "poi_latitude": "38.5753714",
      "poi_longitude": "-121.2898851",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwtcXZHdmoAR6YFK_MFMvsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_ba0cc3f0473e0881ea17bd81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Intel",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1900 Prairie City Rd, Folsom, CA 95630, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-0560-75ee-aa9e-e4fa2a46fa80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0560-75ee-aa9e-e4fa2a46fa80",
        "storage_key": "property/6767906449166882/019d08ac-0560-75ee-aa9e-e4fa2a46fa80.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.intel.com/content/www/us/en/location/usa.html#California",
      "poi_directions_map_url": "https://maps.google.com/?cid=13339657335930848820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intel",
      "poi_latitude": "38.6458405",
      "poi_longitude": "-121.1627621",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-356-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv33XFNPlmoARNIaXpav7H7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_9a618d4f52026d7cea2b2414",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "UC Davis Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 X St, Sacramento, CA 95817, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-0697-71cf-972b-02543d2f5373.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0697-71cf-972b-02543d2f5373",
        "storage_key": "property/6767906449166882/019d08ac-0697-71cf-972b-02543d2f5373.webp",
        "width": 500,
        "height": 330
      },
      "poi_business_url": "https://health.ucdavis.edu/medicalcenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899362877471555770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uc-davis-medical-center",
      "poi_latitude": "38.5547656",
      "poi_longitude": "-121.4552827",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-734-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27b0-704e-ae78-ac68e1242700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27b0-704e-ae78-ac68e1242700",
        "storage_key": "property/6767906449166882/019d08ac-27b0-704e-ae78-ac68e1242700.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4rq2nzQmoARuoD93mLjgHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_65da4f91b7b8d7e662a72b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sutter Medical Center, Sacramento",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2825 Capitol Ave, Sacramento, CA 95816, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-073d-76d9-8444-a6fb55501e57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-073d-76d9-8444-a6fb55501e57",
        "storage_key": "property/6767906449166882/019d08ac-073d-76d9-8444-a6fb55501e57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://suttermedicalcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=562776847767622448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sutter-medical-center-sacramento",
      "poi_latitude": "38.5709021",
      "poi_longitude": "-121.4694505",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-887-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27b0-704e-ae78-ac68e1242700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27b0-704e-ae78-ac68e1242700",
        "storage_key": "property/6767906449166882/019d08ac-27b0-704e-ae78-ac68e1242700.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYvOx-rQmoARMNMAs49izwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_c9a44e9981449ded595dbc2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Sacramento VA Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10535 Hospital Way, Mather, CA 95655, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ab-c002-74bc-989b-19bb936b0e72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c002-74bc-989b-19bb936b0e72",
        "storage_key": "property/6767906449166882/019d08ab-c002-74bc-989b-19bb936b0e72.webp",
        "width": 480,
        "height": 320
      },
      "poi_business_url": "https://www.va.gov/northern-california-health-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671437030510185164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacramento-va-medical-center",
      "poi_latitude": "38.5725922",
      "poi_longitude": "-121.2966576",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-382-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27ad-77c2-b8a0-b31ea0a2beba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27ad-77c2-b8a0-b31ea0a2beba",
        "storage_key": "property/6767906449166882/019d08ac-27ad-77c2-b8a0-b31ea0a2beba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83XUHDLdmoARzEpiS9PZEiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_ee9c3b9f00f654b28eab86fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Kaiser Permanente Rancho Cordova Medical Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10725 International Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-0844-726c-8bda-9abf220985a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0844-726c-8bda-9abf220985a1",
        "storage_key": "property/6767906449166882/019d08ac-0844-726c-8bda-9abf220985a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/northern-california/facilities/Rancho-Cordova-Medical-Offices-100338",
      "poi_directions_map_url": "https://maps.google.com/?cid=4845393240971836795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaiser-permanente-rancho-cordova-medical-offices",
      "poi_latitude": "38.5770848",
      "poi_longitude": "-121.2924945",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 916-631-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_5kxzDdmoARe300DXtLPkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_1ab8c4389ea44d5ecb38a539",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "Rancho Cordova City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2729 Prospect Park Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-0fa6-74ee-823b-383f14885dc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0fa6-74ee-823b-383f14885dc1",
        "storage_key": "property/6767906449166882/019d08ac-0fa6-74ee-823b-383f14885dc1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.cityofranchocordova.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9712799136449957214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rancho-cordova-city-hall",
      "poi_latitude": "38.5892875",
      "poi_longitude": "-121.284565",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-851-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-27ad-77c2-b8a0-b31ea0a2beba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-27ad-77c2-b8a0-b31ea0a2beba",
        "storage_key": "property/6767906449166882/019d08ac-27ad-77c2-b8a0-b31ea0a2beba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfmFE0DdmoARXg3SnlrLyoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_0eb1c1bd4d55f947e0d7aaaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "SMUD",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6301 S St, Sacramento, CA 95817, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-0e2e-73ae-a5d4-cc1d6ce22585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0e2e-73ae-a5d4-cc1d6ce22585",
        "storage_key": "property/6767906449166882/019d08ac-0e2e-73ae-a5d4-cc1d6ce22585.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.smud.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16542875989121509439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smud",
      "poi_latitude": "38.5519899",
      "poi_longitude": "-121.4291968",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-742-7683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-19b5-7749-945a-f2d0f7f9fb87",
        "storage_key": "property/6767906449166882/019d08ac-19b5-7749-945a-f2d0f7f9fb87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36FX25DamoARPyjtbhAalOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_d052922699e312dea3626a63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "poi_name": "California State University, Sacramento",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6000 Jed Smith Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-110d-75a8-9593-a86f45fa1629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-110d-75a8-9593-a86f45fa1629",
        "storage_key": "property/6767906449166882/019d08ac-110d-75a8-9593-a86f45fa1629.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://csus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8520208179546512258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "california-state-university-sacramento",
      "poi_latitude": "38.560824",
      "poi_longitude": "-121.423993",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-278-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-20bf-741e-8554-fba6442fb5f2",
        "storage_key": "property/6767906449166882/019d08ac-20bf-741e-8554-fba6442fb5f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_TGMY3amoARgls_gjLcPXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2a5df45416263d519167393a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_c4390834f295aa6b3cfb0cc0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_af4ea68c498a4b28ce09fe69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_a051f6f4118793acbee21115",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_2be3cdc114f75c90fe6dca8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_fc7c686f3a4340a5a9ad3922",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_288dd98d14a764feb1e8c41c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "rating": "4",
      "name": "false",
      "text": "I love the value of what you get for the amount of rent. This place is in a great location. Easy access to the Freeway, Restaurants, Shopping, Grocery stores, Parks, Athletic Facility, and more. It's very Convenient to Folsom, Roseville, Downtown, Arden, You name it.\n\nThe Staff here is Awesome. Very friendly and helpful. They are available 7 days a week. Even Maintenance is 7 days a week. You can easily make requests online, and they typically have it fixed the next day. Speaking of online, we can also pay rent, water, sewage, and trash online. No more waiting in line for money orders!!\n\nThe apartment itself is quite nice. The Kitchen, Living Room, and Dining Room space is an open floor plan that makes it easy to stay connected with family & guests. There is also a sizable Private Patio/Balcony space w/ Extra Storage.  \n\nI absolutely love the Full Size Washer & Dryer inside the unit, and the Extra Storage above each machine. The bedroom is wonderful with a closet that runs along the entire length of the room.  Plus, there is a full size Bathroom with a Tub & Shower.\n\n\nThe complex has a couple of Pools/Hot Tubs, Fitness Facility, Free Wifi in the Business Center/Office, and a Tanning Bed. What else can you ask for with Low Rent Prices like these?\n\nThis is an amazing value!!",
      "date": "false",
      "title": "Great Value"
    },
    {
      "id": "ec_c0d4d5fd6e62c7fdde9982e0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "rating": "4",
      "name": "false",
      "text": "I've lived at zinfandel village for almost a year and absolutely love it. The staff is friendly, location is perfect and really, it's got everything! Full size washer and dryer,  lots of cabinets and storage, updated units, pet friendly,  fast maintenance response,  pools, gym, tanning beds... seriously.  The only reason I'll move is that rent goes up a lot more than my pay rate. I definitely recommend zinfandel village!  :)",
      "date": "false",
      "title": "Couldn't ask for more"
    },
    {
      "id": "ec_a4863c6aa0aeb8f0010da3fb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "rating": "5",
      "name": "false",
      "text": "Our apartment is wonderful, great place to raise a family, it's a quiet neighborhood. The staff is very friendly and I'm so happy that there is a washer and dryer inside the apartment. Great pools, gym,tanning bed, and a small playground if u have kids.",
      "date": "false",
      "title": "Appartment"
    },
    {
      "id": "ec_93d4c2ac98aa070e5fce73a7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "rating": "5",
      "name": "false",
      "text": "I've been living here for nearly two years and love this place. The apartments are very nice and the area is as well, but the staff is what sells it. The office is quick to help you with any issues that may arise. (Which almost never happens) Recently, I misplaced a gift card that came in a little box, I must have dropped in when running from my car in the rain, and was quite upset about it. The next day however, I get a call from the office asking if maybe I lost something. I told them yes I lost a gift card that came in a little box. I couldn't believe that they figured out it was mine since it only had my first name written in it! One of the maintenance workers had found it and turned it into the office. I was so happy to get the gift card back!  That's quality service that I truly did not expect. Great place to live since the people running it care about you.",
      "date": "false",
      "title": "Great Staff!"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_656c1dd9-89ef-42e9-8766-871478b8fe59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d20b8-697d-710e-861d-1970f93dab7c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with white cabinets and a white door.",
        "public_id": "019d20b8-697d-710e-861d-1970f93dab7c",
        "storage_key": "property/6767906449166882/019d20b8-697d-710e-861d-1970f93dab7c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1x1 Floor Plan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wycfiuvxfgs"
    },
    {
      "id": "custom_a44ab1a9-fb00-4930-8e46-0aa396cd1616",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d20b8-697d-710e-861d-1f1eb8cfb45b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with gray sofa, armchair, and abstract art.",
        "public_id": "019d20b8-697d-710e-861d-1f1eb8cfb45b",
        "storage_key": "property/6767906449166882/019d20b8-697d-710e-861d-1f1eb8cfb45b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x1.3 Floor Plan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=epcB9k7RHZx"
    },
    {
      "id": "custom_afe34201-a189-49a9-8178-d6779de2942d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d20b8-699d-7469-9d23-8508497bc75e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and living room area with sliding glass doors to a balcony.",
        "public_id": "019d20b8-699d-7469-9d23-8508497bc75e",
        "storage_key": "property/6767906449166882/019d20b8-699d-7469-9d23-8508497bc75e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x2 Floor Plan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BHxoiyTQgs6"
    },
    {
      "id": "custom_a6ebc2f6-8ceb-4033-8ddc-0edd16fee8a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d20b8-694c-70fd-9fb1-dc8e4079def1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with black granite countertops, white cabinets, black appliances, and a sliding glass door to a balcony.",
        "public_id": "019d20b8-694c-70fd-9fb1-dc8e4079def1",
        "storage_key": "property/6767906449166882/019d20b8-694c-70fd-9fb1-dc8e4079def1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3x2 Floor Plan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SiV5NXC61vx"
    },
    {
      "id": "custom_53ac9aca-18be-471f-aa80-7ca0f6ea1a4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d20b8-71de-7655-8ec0-9510484cd19f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019d20b8-71de-7655-8ec0-9510484cd19f",
        "storage_key": "property/6767906449166882/019d20b8-71de-7655-8ec0-9510484cd19f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ShJTVqXjjkh"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a9d42-e885-711e-ac3d-743864ea7b24",
      "lead_source": "LANDING_PAGE",
      "name": "ctl-zinfandel-village-apartments-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-dog-parks-rancho-cordova",
      "search_query": "apartments with dog parks in Rancho Cordova",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Parks in Rancho Cordova",
      "h2_subtitle": "Discover pet-friendly living at Zinfandel Village Apartments. Our community in Rancho Cordova offers a serene Bark Park for your furry friend's delight.",
      "page_copy": "Welcome to Zinfandel Village Apartments, where pet-friendly living meets modern comfort in Rancho Cordova. Our community proudly features a serene Bark Park, making it an ideal choice for those seeking apartments with dog parks in Rancho Cordova. Your four-legged companions will love the open space to run and play while you enjoy the warm California sunshine.\n\nBeyond our pet-friendly amenities, Zinfandel Village offers various floor plans, from cozy one-bedroom apartments to expansive three-bedroom homes, tailored to fit your lifestyle. Experience the convenience of online rent payments and 24-hour package lockers, alongside vibrant resident activities. Come visit us and see why we're the perfect place for you and your pet to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Parks | Rancho Cordova",
      "seo_description": "Zinfandel Village offers pet-friendly apartments with a Bark Park in Rancho Cordova. Discover vibrant living for you and your pets!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-rental-homes-garages-sacramento-county",
      "search_query": "rental homes with garages Sacramento County",
      "category": "Amenity",
      "h1_title": "Rental Homes with Garages in Sacramento County",
      "h2_subtitle": "Find your ideal home at Zinfandel Village Apartments. Our Rancho Cordova community offers spacious rental homes with convenient garages.",
      "page_copy": "Zinfandel Village Apartments offers stylish living in the heart of Rancho Cordova, providing rental homes with garages that cater to both convenience and privacy. Nestled in Sacramento County, our homes are designed with you in mind, offering garage spaces perfect for your vehicles or extra storage needs.\n\nChoose from a range of floor plans, whether you're looking for a cozy one-bedroom retreat or a spacious three-bedroom home. Along with the benefit of garages, enjoy amenities such as a serene Bark Park and vibrant resident activities. Our community also offers hassle-free online rent payments and secure 24-hour package lockers. Discover comfortable living with easy access to all the benefits Sacramento County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes with Garages | Sacramento County",
      "seo_description": "Explore Zinfandel Village for rental homes with garages in Sacramento County. Enjoy convenience and comfort in Rancho Cordova.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-smoke-free-apartments-rancho-cordova",
      "search_query": "smoke free apartments in Rancho Cordova CA",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Rancho Cordova, CA",
      "h2_subtitle": "Enjoy a fresh living environment at Zinfandel Village. Our smoke-free apartments in Rancho Cordova promote wellness and comfort.",
      "page_copy": "At Zinfandel Village Apartments, we understand the importance of a healthy living environment. Our smoke-free apartments in Rancho Cordova, CA, offer fresh air and a clean atmosphere, ideal for residents who prioritize wellness. Our community emphasizes comfort without compromising on lifestyle.\n\nAlongside our smoke-free policy, residents can explore a wide variety of amenities, from our quiet Bark Park to vibrant activity programs that engage and entertain. Choose from various floor plans, whether a cozy one-bedroom or a spacious three-bedroom home fits your needs. Experience the convenience of online rent payments and secure 24-hour package lockers. Discover serene living in the heart of Rancho Cordova.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments | Rancho Cordova, CA",
      "seo_description": "Zinfandel Village provides smoke-free apartments in Rancho Cordova, CA. Enjoy healthy living with great amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-24-hour-package-lockers-rancho-cordova",
      "search_query": "24-hour package lockers Rancho Cordova",
      "category": "Amenity",
      "h1_title": "24-Hour Package Lockers in Rancho Cordova",
      "h2_subtitle": "Experience secure living with Zinfandel Village Apartments. Our Rancho Cordova community offers 24-hour package lockers for your convenience.",
      "page_copy": "Zinfandel Village Apartments in Rancho Cordova ensures your package deliveries are safe and secure with our 24-hour package lockers. This modern amenity is designed to provide residents with peace of mind knowing their packages are protected around the clock, adding an extra layer of convenience to your daily life.\n\nOur apartments offer more than just package security. Enjoy a range of amenities including a serene Bark Park and engaging resident activity programs. Choose from various floor plan options, whether you need a cozy one-bedroom or a larger three-bedroom home, all set within a welcoming community atmosphere. Discover a stress-free living experience with the convenience of online rent payments and fantastic community features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Package Lockers | Rancho Cordova",
      "seo_description": "Secure your deliveries with 24-hour package lockers at Zinfandel Village in Rancho Cordova. Enjoy convenience and peace of mind where you live.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-coffee-bar-apartments-sacramento-county",
      "search_query": "coffee bar apartments in Sacramento County",
      "category": "Amenity",
      "h1_title": "Coffee Bar Apartments in Sacramento County",
      "h2_subtitle": "Savor life at Zinfandel Village Apartments. Our community in Sacramento County offers delightful amenities, including a coffee bar for residents.",
      "page_copy": "Wake up to the inviting aroma of freshly brewed coffee at Zinfandel Village Apartments, where our Sacramento County location features a community coffee bar. This cozy amenity is perfect for enjoying a morning brew while socializing with neighbors or simply relaxing with your favorite book.\n\nIn addition to our delightful coffee bar, residents enjoy a host of other amenities, including a serene Bark Park and an active resident program. Our smoke-free community offers various floor plans, from comfortable one-bedroom residences to spacious three-bedroom homes, ensuring we have the perfect fit for you. Enjoy hassle-free living with conveniences like 24-hour package lockers and online rent payments, all in the vibrant setting of Rancho Cordova.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Coffee Bar Apartments | Sacramento County",
      "seo_description": "Discover comfortable living at Zinfandel Village, featuring coffee bar apartments in Sacramento County. Enjoy a welcoming community atmosphere and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-one-bedroom-apartments-rancho-cordova",
      "search_query": "one bedroom apartments in Rancho Cordova",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Rancho Cordova",
      "h2_subtitle": "Discover cozy and convenient living at Zinfandel Village. Our one-bedroom apartments in Rancho Cordova perfectly blend style and comfort.",
      "page_copy": "At Zinfandel Village, our one-bedroom apartments in Rancho Cordova offer the perfect retreat for individuals seeking comfort and style. Each unit is thoughtfully designed to maximize space, providing a welcoming environment that feels like home from the moment you step in.\n\nOur community extends beyond comfortable living spaces with amenities that cater to all lifestyles. Enjoy our private Bark Park, engage in resident activities, and utilize our secure 24-hour package lockers. Living here means embracing convenience with options like online rent payments, all while being nestled in a friendly, smoke-free community. Explore Zinfandel Village and find your ideal one-bedroom apartment today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments | Rancho Cordova",
      "seo_description": "Find your ideal one-bedroom apartment at Zinfandel Village in Rancho Cordova. Enjoy stylish living with fantastic amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-two-bedroom-apartments-sacramento-county",
      "search_query": "two bedroom apartments in Sacramento County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Sacramento County",
      "h2_subtitle": "Explore spacious living at Zinfandel Village. Our Sacramento County community offers inviting two-bedroom apartments perfect for any lifestyle.",
      "page_copy": "Zinfandel Village Apartments in Sacramento County presents spacious two-bedroom apartments that seamlessly blend comfort and functionality. These thoughtfully designed spaces are ideal for families, roommates, or anyone needing extra room, offering an inviting layout that meets diverse needs.\n\nBeyond the welcoming interiors, our community provides a range of amenities including a peaceful Bark Park and an engaging resident activity program. Convenient features such as 24-hour package lockers and online rent payments make everyday living easy and stress-free. Located in the heart of Rancho Cordova, Zinfandel Village is more than just a place to live—it's a vibrant community where you can truly feel at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments | Sacramento County",
      "seo_description": "Discover spacious two-bedroom apartments at Zinfandel Village in Sacramento County. Enjoy convenient amenities and a community-focused lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-three-bedroom-apartments-near-95670",
      "search_query": "three bedroom apartments near 95670",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 95670",
      "h2_subtitle": "Find ample space at Zinfandel Village. Our three-bedroom apartments near 95670 offer the perfect blend of space and convenience.",
      "page_copy": "For those seeking a spacious living environment near the 95670 area, Zinfandel Village Apartments offers an exceptional selection of three-bedroom homes. Designed to cater to larger households or those needing additional room, these apartments provide comfort without compromising on style or functionality.\n\nEnjoy life in a community that offers more than just a place to live. With amenities like a residents' Bark Park, an engaging activity program, and convenient 24-hour package lockers, Zinfandel Village ensures a balanced lifestyle. Online rent payments and other resident-oriented features make living here both easy and enjoyable. Discover your new home at Zinfandel Village, nestled in the vibrant community of Rancho Cordova.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments | Near 95670",
      "seo_description": "Explore spacious three-bedroom apartments at Zinfandel Village near 95670. Enjoy vibrant community life with extensive amenities and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-cordova-villa-elementary",
      "search_query": "apartments near Cordova Villa Elementary School Rancho Cordova",
      "category": "School",
      "h1_title": "Apartments Near Cordova Villa Elementary School",
      "h2_subtitle": "Zinfandel Village offers ideal living for families. Find apartments near Cordova Villa Elementary School in Rancho Cordova and join our welcoming community.",
      "page_copy": "Located conveniently in Rancho Cordova, Zinfandel Village Apartments provide a great living option for families, particularly those prioritizing education. Our community is situated near Cordova Villa Elementary School, allowing for easy access to quality educational facilities.\n\nAt Zinfandel Village, residents enjoy more than just proximity to school; the community boasts amenities such as a serene Bark Park, engaging resident activities, and accommodations like online rent payment options. Experience family-friendly living with the added benefits of community-centric amenities. Zinfandel Village is the ideal choice for those looking to combine convenience with community spirit in Rancho Cordova.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cordova Villa Elementary School",
      "seo_description": "Discover family-friendly apartments near Cordova Villa Elementary School at Zinfandel Village in Rancho Cordova. Enjoy convenient living in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-living-by-white-rock-elementary",
      "search_query": "Zinfandel Village living by White Rock Elementary School",
      "category": "School",
      "h1_title": "Zinfandel Village Living by White Rock Elementary",
      "h2_subtitle": "Enjoy community-focused living at Zinfandel Village. Perfectly located by White Rock Elementary School, our apartments offer convenience and comfort in Rancho Cordova.",
      "page_copy": "Zinfandel Village Apartments offers a prime location for families seeking proximity to White Rock Elementary School in Rancho Cordova. Our community-focused living environment is ideal for families who wish to combine convenience with comfort, offering spacious apartments just a short distance from the school.\n\nResidents enjoy a vibrant community life with amenities like a resident activity program and a Bark Park that caters to both families and pets. Additional conveniences such as garages and online rent payments make daily life easier. Discover the benefits of living at Zinfandel Village, where community spirit and optimal location unite to create a wonderful living experience near White Rock Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village by White Rock Elementary School",
      "seo_description": "Experience living at Zinfandel Village by White Rock Elementary. Enjoy community amenities and comfort in Rancho Cordova, perfect for family living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-near-navigator-elementary-sacramento",
      "search_query": "nearby apartments to Navigator Elementary School Sacramento County",
      "category": "School",
      "h1_title": "Nearby Apartments to Navigator Elementary",
      "h2_subtitle": "Discover homes close to Navigator Elementary School. Zinfandel Village offers ideal apartments in Sacramento County for families and students alike.",
      "page_copy": "For families in Sacramento County seeking proximity to Navigator Elementary School, Zinfandel Village Apartments is an excellent choice. Situated conveniently, our apartments provide a perfect living option for those desiring quick access to quality education while enjoying a vibrant community atmosphere.\n\nZinfandel Village is more than just a place to live; it offers amenities that promote a balanced lifestyle, such as a Bark Park, resident-focused activities, and the convenience of 24-hour package lockers. With spacious floor plans ranging from one to three bedrooms, this community caters to various needs, all within a short drive from Navigator Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Navigator Elementary School",
      "seo_description": "Find family-friendly apartments near Navigator Elementary School at Zinfandel Village in Sacramento County, offering convenience and excellent community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-mills-middle-school",
      "search_query": "Mills Middle School nearby apartment homes",
      "category": "School",
      "h1_title": "Mills Middle School Nearby Apartment Homes",
      "h2_subtitle": "Find the ideal apartment home near Mills Middle School. Zinfandel Village offers vibrant living options in Rancho Cordova, perfect for families and students.",
      "page_copy": "Zinfandel Village Apartments offers ideal solutions for those seeking community living in close proximity to Mills Middle School in Rancho Cordova. Our apartment homes provide the perfect balance of convenience and comfort, making them well-suited for families with school-age children.\n\nThe community features enriching amenities such as a Bark Park and a resident activity program, ensuring both families and pets feel at home. Zinfandel Village also offers practical conveniences like garages and online rent payments, enhancing resident experiences. Enjoy spacious living with easy access to Mills Middle School, ensuring a seamless lifestyle for every family member.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Mills Middle School",
      "seo_description": "Discover apartment homes near Mills Middle School at Zinfandel Village in Rancho Cordova. Enjoy community amenities perfect for families and students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-cordova-high-school",
      "search_query": "proximity apartments Cordova High School CA",
      "category": "School",
      "h1_title": "Proximity Apartments to Cordova High School CA",
      "h2_subtitle": "Explore apartments close to Cordova High School. Zinfandel Village offers a prime location and amenities in Rancho Cordova, CA.",
      "page_copy": "Situated in Rancho Cordova, CA, Zinfandel Village Apartments provides a prime location for families desiring proximity to Cordova High School. Our community offers convenient access to the school, making it an excellent choice for students and families seeking an enriching and engaging living environment.\n\nZinfandel Village provides a range of amenities that cater to both lifestyle and convenience, including a Bark Park, resident activity programs, and 24-hour package lockers. These features, along with spacious one to three-bedroom floor plans, make it easy to enjoy a vibrant community life while staying close to Cordova High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cordova High School CA",
      "seo_description": "Find proximity apartments near Cordova High School at Zinfandel Village in Rancho Cordova, CA. Enjoy excellent amenities and a great community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-rancho-cordova-elementary",
      "search_query": "Rancho Cordova Elementary School apartments",
      "category": "School",
      "h1_title": "Rancho Cordova Elementary School Apartments",
      "h2_subtitle": "Discover top-tier apartments near Rancho Cordova Elementary School. Experience easy living at Zinfandel Village, located in the heart of Rancho Cordova.",
      "page_copy": "Zinfandel Village Apartments is an ideal choice for families seeking homes near Rancho Cordova Elementary School. Located in the heart of Rancho Cordova, our community offers convenient access to top-tier education and everything you need for a comfortable lifestyle.\n\nWith thoughtfully designed floor plans from one to three bedrooms, Zinfandel Village blends stylish living with practical amenities like a Bark Park, garages, and online rent payment options. Our resident activity program ensures a vibrant community atmosphere, making it a great place for families with young children attending Rancho Cordova Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rancho Cordova Elementary School",
      "seo_description": "Discover Zinfandel Village Apartments near Rancho Cordova Elementary. Offering amenities and access perfect for families in Rancho Cordova.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-cordova-meadows-elementary",
      "search_query": "Cordova Meadows Elementary School close by living",
      "category": "School",
      "h1_title": "Close By Living Near Cordova Meadows Elementary",
      "h2_subtitle": "Enjoy close by living near Cordova Meadows Elementary School at Zinfandel Village. Find your ideal home in the heart of Rancho Cordova.",
      "page_copy": "Experience the convenience of close by living at Zinfandel Village Apartments, located near Cordova Meadows Elementary School. Nestled in Rancho Cordova, our community provides families with the perfect blend of accessibility and comfort for those with young students.\n\nAt Zinfandel Village, you can choose from a variety of floor plans suited to fit your family's needs, all while enjoying amenities such as a serene Bark Park and vibrant resident activities. Our practical features include 24-hour package lockers and garages, making day-to-day life hassle-free. Discover the welcoming community atmosphere right here in Rancho Cordova, CA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Cordova Meadows Elementary School",
      "seo_description": "Live close by Cordova Meadows Elementary at Zinfandel Village in Rancho Cordova. Enjoy family-friendly living and modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-riverview-stem-academy",
      "search_query": "apartments near Riverview STEM Academy Rancho Cordova",
      "category": "School",
      "h1_title": "Apartments Near Riverview STEM Academy",
      "h2_subtitle": "Find ideal apartments close to Riverview STEM Academy in Rancho Cordova. Zinfandel Village offers convenience and comfort for innovative living.",
      "page_copy": "Zinfandel Village Apartments in Rancho Cordova offers an excellent location for families seeking close proximity to Riverview STEM Academy. Our community provides easy access to this innovative educational institution, making it a preferred choice for families prioritizing specialized learning opportunities.\n\nZinfandel Village features diverse floor plans from one to three bedrooms, paired with amenities like a Bark Park and convenient online services. Our vibrant resident activity program and 24-hour package lockers ensure you have everything you need at hand, enhancing the ease and joy of everyday life while staying near Riverview STEM Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riverview STEM Academy",
      "seo_description": "Discover Zinfandel Village Apartments near Riverview STEM Academy in Rancho Cordova. Enjoy modern living and convenient amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-peter-j-shields-elementary",
      "search_query": "Peter J Shields Elementary School nearby residences",
      "category": "School",
      "h1_title": "Nearby Residences at Peter J Shields Elementary",
      "h2_subtitle": "Explore nearby residences to Peter J Shields Elementary School. Zinfandel Village in Rancho Cordova offers the perfect community for families.",
      "page_copy": "Zinfandel Village Apartments offers a prime location for families with students attending Peter J Shields Elementary School. Situated in the vibrant community of Rancho Cordova, our residences provide easy access to quality education and a welcoming environment for families.\n\nChoose from our selection of one to three-bedroom apartments, each designed for comfort and style. Enjoy fantastic amenities, including a Bark Park, garages, and a robust resident activity program. With online rent payment and 24-hour package lockers, living at Zinfandel Village is convenient and hassle-free, providing ideal nearby residences for young scholars.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Residences Peter J Shields Elementary",
      "seo_description": "Zinfandel Village offers residences near Peter J Shields Elementary in Rancho Cordova. Enjoy family-friendly living and modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-convenient-living-near-american-river-college",
      "search_query": "convenient living near American River College 95670",
      "category": "School",
      "h1_title": "Convenient Living Near American River College",
      "h2_subtitle": "Enjoy convenient living near American River College in the 95670 area. Discover Zinfandel Village Apartments for student-friendly amenities.",
      "page_copy": "Experience convenient living at Zinfandel Village Apartments, ideally located near American River College in the 95670 area. Our community is perfect for students and faculty seeking easy access to campus and a comfortable home environment.\n\nAt Zinfandel Village, residents can choose from various floor plans, providing the perfect fit for solo living or roommate arrangements. Enjoy amenities like a serene Bark Park and a vibrant resident activity program. With garages and 24-hour package lockers, living here offers everything for a streamlined lifestyle, just minutes from American River College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Living Near American River College",
      "seo_description": "Discover Zinfandel Village Apartments near American River College in the 95670 area. Enjoy living with modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-sacramento-va-medical-center",
      "search_query": "apartments near Sacramento VA Medical Center Rancho Cordova",
      "category": "Hospital",
      "h1_title": "Apartments Near Sacramento VA Medical Center",
      "h2_subtitle": "Find ideal apartments near Sacramento VA Medical Center in Rancho Cordova. Zinfandel Village offers convenience and comfort nearby.",
      "page_copy": "Zinfandel Village Apartments in Rancho Cordova is the perfect choice for those seeking residences close to the Sacramento VA Medical Center. Whether you're a healthcare professional or require frequent visits, our convenient location ensures easy commuting.\n\nOur community offers a variety of floor plans, from peaceful one-bedroom units to spacious three-bedroom homes. Enjoy amenities like our Bark Park and garages, designed for the ultimate convenience. The engaging resident activity program and online services enhance your living experience. At Zinfandel Village, comfort meets accessibility near the Sacramento VA Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sacramento VA Medical Center",
      "seo_description": "Discover Zinfandel Village Apartments near Sacramento VA Medical Center in Rancho Cordova. Enjoy convenient living with modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-close-to-mercy-san-juan",
      "search_query": "apartments close to Mercy San Juan Medical Center Sacramento County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Mercy San Juan Medical",
      "h2_subtitle": "Discover apartments close to Mercy San Juan Medical Center in Sacramento County. Zinfandel Village offers ideal living options nearby.",
      "page_copy": "Experience the convenience of living at Zinfandel Village Apartments, perfectly located close to Mercy San Juan Medical Center in Sacramento County. Ideal for healthcare staff and patients seeking proximity, our community ensures a comfortable and hassle-free commute.\n\nChoose from a range of floor plans at Zinfandel Village, suited for individuals or families. Equipped with modern amenities like garages, a Bark Park, and vibrant resident activities, our apartments are designed for a balanced lifestyle. With 24-hour package lockers and online rent payments, life here is both simple and enjoyable, just minutes from Mercy San Juan Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mercy San Juan Medical Center",
      "seo_description": "Find Zinfandel Village Apartments close to Mercy San Juan Medical Center in Sacramento County. Enjoy modern, convenient living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-river-bend-park",
      "search_query": "apartments near river bend park rancho cordova",
      "category": "Park",
      "h1_title": "Apartments Near River Bend Park",
      "h2_subtitle": "Explore apartments near River Bend Park in Rancho Cordova. Zinfandel Village offers an ideal location for nature lovers.",
      "page_copy": "Zinfandel Village Apartments offers an outstanding location for those looking to enjoy the natural beauty of River Bend Park in Rancho Cordova. Our community is just a stone's throw away, making it easy to indulge in outdoor activities and scenic views.\n\nWith floor plans ranging from cozy one-bedroom retreats to expansive three-bedroom homes, Zinfandel Village provides the perfect living space for any lifestyle. Our amenities, like a serene Bark Park and engaging resident activity program, make living here a unique experience, blending nature and modern convenience seamlessly. Discover life at Zinfandel Village, close to River Bend Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near River Bend Park - Zinfandel Village",
      "seo_description": "Discover Zinfandel Village Apartments near River Bend Park in Rancho Cordova. Enjoy nature and modern living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-close-to-the-village-green",
      "search_query": "zinfandel village close to the village green sac county",
      "category": "Park",
      "h1_title": "Zinfandel Village Near The Village Green",
      "h2_subtitle": "Experience Zinfandel Village, close to The Village Green in Sac County. Enjoy the best of community and convenience.",
      "page_copy": "Situated in the heart of Sacramento County, Zinfandel Village Apartments offers an ideal location close to The Village Green, providing residents with easy access to this vibrant community hub. Whether you're looking to enjoy a leisurely stroll or participate in local events, The Village Green is just moments away.\n\nAt Zinfandel Village, you'll find a variety of floor plans, including one, two, and three-bedroom options, tailored to fit your lifestyle. Our community boasts a range of amenities, such as garages and a dedicated Bark Park, ensuring comfort and convenience. Embrace a lively, connected living experience at Zinfandel Village, close to The Village Green.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village Apartments Near The Village Green",
      "seo_description": "Discover Zinfandel Village Apartments near The Village Green in Sacramento County. Enjoy community-focused living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-mather-regional-park",
      "search_query": "apartments near mather regional park ca",
      "category": "Park",
      "h1_title": "Apartments Near Mather Regional Park",
      "h2_subtitle": "Find your new home near Mather Regional Park, CA. Zinfandel Village offers proximity and comfort.",
      "page_copy": "Zinfandel Village Apartments offers the perfect blend of convenience and natural beauty for those seeking a home near Mather Regional Park in CA. Just minutes away, our community provides easy access to the park's expansive green spaces and recreational opportunities, ideal for outdoor enthusiasts.\n\nChoose from a selection of thoughtfully designed floor plans at Zinfandel Village, ranging from one to three bedrooms, each equipped with modern amenities. Residents enjoy features such as a Bark Park and 24-hour package lockers, enhancing the ease of everyday living. Relish the serene setting near Mather Regional Park while benefiting from the vibrant community spirit at Zinfandel Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mather Regional Park - Zinfandel",
      "seo_description": "Live at Zinfandel Village Apartments near Mather Regional Park, CA. Enjoy modern living with easy access to outdoor adventures.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-rossmoor-bar",
      "search_query": "zinfandel village apartments rossmoor bar river access",
      "category": "Park",
      "h1_title": "Zinfandel Village with Rossmoor Bar River Access",
      "h2_subtitle": "Enjoy river access at Zinfandel Village near Rossmoor Bar. Experience the tranquility and convenience of riverside living.",
      "page_copy": "Nestled in Rancho Cordova, Zinfandel Village Apartments offers unparalleled access to the scenic views and outdoor activities provided by Rossmoor Bar. Residents can easily enjoy riverside adventures, whether it's a relaxing day by the water or exploring the surrounding trails.\n\nZinfandel Village features a range of floor plans from cozy one-bedroom options to spacious three-bedroom homes, perfect for any lifestyle. Enjoy amenities like garages, a dedicated Bark Park, and online rent payments that make everyday life both convenient and enjoyable. Discover the blend of natural beauty and modern comfort at Zinfandel Village, with effortless access to Rossmoor Bar's river access.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village with Rossmoor Bar Access",
      "seo_description": "Explore riverside living at Zinfandel Village Apartments near Rossmoor Bar. Enjoy the convenience of river access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-near-sunrise-recreation-area",
      "search_query": "apartments close to sunrise recreation area 95670",
      "category": "Park",
      "h1_title": "Apartments Close to Sunrise Recreation Area",
      "h2_subtitle": "Find your ideal living near Sunrise Recreation Area in 95670. Zinfandel Village offers prime location and amenities.",
      "page_copy": "Zinfandel Village Apartments is ideally located in Rancho Cordova, CA, placing residents conveniently close to the Sunrise Recreation Area. This prime location allows you to enjoy easy access to a variety of outdoor activities and scenic views that the recreation area has to offer.\n\nAt Zinfandel Village, you can choose from a selection of floor plans, including one to three-bedroom apartments that are perfect for any lifestyle. The community offers attractive features such as a Bark Park, garages, and a robust resident activity program. With its close proximity to the Sunrise Recreation Area in the 95670 ZIP code, Zinfandel Village provides an unrivaled blend of comfort and recreation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sunrise Recreation Area 95670",
      "seo_description": "Discover Zinfandel Village Apartments near Sunrise Recreation Area, 95670. Enjoy convenience and community in a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-apartments-near-sunriver-park",
      "search_query": "zinfandel village near sunriver park rancho cordova ca",
      "category": "Park",
      "h1_title": "Zinfandel Village Near Sunriver Park",
      "h2_subtitle": "Explore life at Zinfandel Village, close to Sunriver Park in Rancho Cordova, CA. Enjoy natural beauty and community vibes.",
      "page_copy": "Experience the comfort of living at Zinfandel Village Apartments, a community that's perfectly situated near Sunriver Park in Rancho Cordova, CA. This ideal location provides residents with the opportunity to enjoy leisurely walks or active lifestyle options just moments away from home.\n\nOffering a variety of floor plans, from one-bedroom retreats to spacious three-bedroom homes, Zinfandel Village caters to diverse needs. Residents benefit from fantastic amenities such as a serene Bark Park, garages, and online rent payments. Embrace the blend of peaceful park proximity with engaging community events at Zinfandel Village, making it a wonderful place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village Near Sunriver Park, CA",
      "seo_description": "Live at Zinfandel Village Apartments near Sunriver Park, Rancho Cordova. Enjoy proximity to parks and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-near-dave-roberts-community-park",
      "search_query": "zinfandel village apartments close to dave roberts community park",
      "category": "Park",
      "h1_title": "Zinfandel Village Near Dave Roberts Park",
      "h2_subtitle": "Discover Zinfandel Village Apartments close to Dave Roberts Community Park, offering modern living with outdoor access.",
      "page_copy": "At Zinfandel Village Apartments, you'll find the perfect balance of modern living and nature, situated close to Dave Roberts Community Park in Rancho Cordova. This location allows you to enjoy the park's sporting facilities, playgrounds, and open spaces just a short distance from home.\n\nChoose from a variety of floor plans, whether you're seeking a cozy one-bedroom or a spacious three-bedroom apartment. Residents of Zinfandel Village enjoy exceptional amenities including a relaxing Bark Park, convenient garages, and the ease of online rent payment options. With the added advantage of being near Dave Roberts Community Park, this community combines convenience with a vibrant lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village Near Dave Roberts Park",
      "seo_description": "Live at Zinfandel Village Apartments near Dave Roberts Community Park. Experience modern amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-near-hagan-community-park",
      "search_query": "apartments near hagan community park sacramento county",
      "category": "Park",
      "h1_title": "Apartments Near Hagan Community Park",
      "h2_subtitle": "Find your home at Zinfandel Village, conveniently located near Hagan Community Park in Sacramento County.",
      "page_copy": "Discover the ideal living situation at Zinfandel Village Apartments, located just a short drive from Hagan Community Park. Nestled in Sacramento County, this community offers easy access to the park's extensive trails, sports fields, and vibrant green spaces, perfect for those who enjoy outdoor activities.\n\nZinfandel Village boasts a variety of floor plans, catering from intimate one-bedroom units to expansive three-bedroom homes. Residents can enjoy amenities like a welcoming Bark Park and a program of engaging resident activities. Stay connected with online rent payments and relish the community spirit, all while being close to the natural beauty of Hagan Community Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hagan Park Sacramento County",
      "seo_description": "Explore Zinfandel Village Apartments near Hagan Community Park in Sacramento County. Enjoy a vibrant community close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-village-el-manto-river-access",
      "search_query": "zinfandel village apartments el manto river access 95670",
      "category": "Park",
      "h1_title": "Zinfandel Village Near El Manto River Access",
      "h2_subtitle": "Enjoy living at Zinfandel Village Apartments with easy access to El Manto River in the 95670 area.",
      "page_copy": "Nestled in the heart of the 95670 area, Zinfandel Village Apartments offers residents the unique advantage of being near the serene El Manto River access point. This proximity gives nature enthusiasts easy opportunities for kayaking, fishing, and tranquil riverside strolls just moments from their doorstep.\n\nAt Zinfandel Village, you'll find a range of thoughtfully designed floor plans, from cozy one-bedroom units to more expansive three-bedroom residences. The community features exceptional amenities like a peaceful Bark Park, secure garages, 24-hour package lockers, and an engaging resident activity program. Embrace the blend of natural beauty and modern convenience at Zinfandel Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village Apts Near El Manto River",
      "seo_description": "Live at Zinfandel Village Apartments with El Manto River access in 95670. Enjoy riverside living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "zinfandel-station-apartments-rancho-cordova",
      "search_query": "zinfandel station apartments rancho cordova",
      "category": "Transit",
      "h1_title": "Zinfandel Village: Rancho Cordova Living",
      "h2_subtitle": "Experience vibrant community living at Zinfandel Village Apartments, conveniently situated in Rancho Cordova near Zinfandel Station.",
      "page_copy": "Step into comfortable and contemporary living at Zinfandel Village Apartments, ideally located in Rancho Cordova near the bustling Zinfandel Station. This proximity offers easy access to public transportation, making commutes and city exploration more convenient than ever.\n\nZinfandel Village presents an array of floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Residents can enjoy a host of amenities, such as a serene Bark Park, helpful 24-hour package lockers, and a lively resident activity program. With online rent payment options and garages available, life at Zinfandel Village is both convenient and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village: Rancho Cordova Living",
      "seo_description": "Explore Zinfandel Village Apartments in Rancho Cordova near Zinfandel Station, featuring modern homes and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "apartments-near-cordova-town-center-station",
      "search_query": "apartments near cordova town center station 95670",
      "category": "Transit",
      "h1_title": "Apartments Near Cordova Town Center Station",
      "h2_subtitle": "Live close to Cordova Town Center Station with ease and style at Zinfandel Village Apartments in the 95670 area.",
      "page_copy": "Discover the convenience of living at Zinfandel Village Apartments, situated near the Cordova Town Center Station in the bustling 95670 area. This ideal location provides seamless access to public transit, perfect for those who commute or love exploring the city.\n\nAt Zinfandel Village, residents enjoy a diverse selection of floor plans, from intimate one-bedroom residences to spacious three-bedroom homes, along with exceptional amenities including a Bark Park and a robust resident activity program. Plus, with online rent payments and garages available, Zinfandel Village ensures a convenient and fulfilling lifestyle close to everything Rancho Cordova has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Cordova Town Center Station 95670",
      "seo_description": "Live at Zinfandel Village Apartments near Cordova Town Center Station in 95670. Enjoy easy transit access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "sunrise-station-nearby-apartments-sac-county",
      "search_query": "sunrise station nearby apartments sac county",
      "category": "Transit",
      "h1_title": "Nearby Apartments: Sunrise Station Living",
      "h2_subtitle": "Zinfandel Village Apartments offer prime access to Sunrise Station, nestled comfortably in Sacramento County.",
      "page_copy": "Zinfandel Village Apartments provide a premier living experience with easy access to Sunrise Station, a key transit hub in Sacramento County. This strategic location ensures residents can effortlessly navigate the city while enjoying all the conveniences of suburban life.\n\nOur community presents an array of thoughtfully designed floor plans, ranging from cozy one-bedroom apartments to spacious three-bedroom homes. Indulge in top-tier amenities like our welcoming Bark Park and lively resident activity programs, complemented by modern conveniences such as 24-hour package lockers and online rent payments. At Zinfandel Village, enjoy the perfect blend of accessibility and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sunrise Station Nearby Apts in Sac County",
      "seo_description": "Find Zinfandel Village Apartments near Sunrise Station in Sac County for convenient transit and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "mather-field-mills-station-apartments-rancho-cordova",
      "search_query": "mather field mills station apartments rancho cordova ca",
      "category": "Transit",
      "h1_title": "Zinfandel Village: Mather Field Mills Access",
      "h2_subtitle": "Find your ideal home near Mather Field Mills Station at Zinfandel Village Apartments, nestled in Rancho Cordova, CA.",
      "page_copy": "Embrace the vibrant essence of Rancho Cordova at Zinfandel Village Apartments, conveniently located near Mather Field Mills Station. This prime spot ensures quick access to transit options, making daily commutes and city exploration exceedingly simple and efficient.\n\nZinfandel Village offers a range of floor plans from charming one-bedroom layouts to roomy three-bedroom homes, complemented by amenities like a serene Bark Park and engaging resident activity program. With features such as online rent payments and secure garages, Zinfandel Village Apartments provide a perfect blend of convenience and community near Mather Field Mills Station in the heart of Rancho Cordova, CA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Zinfandel Village: Mather Field Mills Access",
      "seo_description": "Live at Zinfandel Village Apartments, close to Mather Field Mills Station in Rancho Cordova, CA. Enjoy stylish homes and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166882",
      "source": "generator",
      "page_item_url": "apartments-close-to-sacramento-international-airport",
      "search_query": "apartments close to sacramento international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Sacramento Airport",
      "h2_subtitle": "Discover Zinfandel Village Apartments, conveniently located near Sacramento International Airport for easy travel.",
      "page_copy": "Experience unmatched convenience at Zinfandel Village Apartments, strategically located to offer quick access to Sacramento International Airport. This ideal location is perfect for frequent travelers and those seeking a home base with close proximity to major transit points.\n\nResidents at Zinfandel Village enjoy stylish living options, ranging from one-bedroom retreats to expansive three-bedroom homes. Our community features are designed for comfort and ease, including a delightful Bark Park and a host of resident activities. Plus, modern conveniences like online rent payments and secure garages ensure a hassle-free lifestyle, making Zinfandel Village Apartments the perfect choice for those wanting to live close to Sacramento International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green lawns and mature trees.",
        "public_id": "019d08aa-fd2b-74d8-b1c0-75f09c60418d",
        "storage_key": "property/6767906449166882/019d08aa-fd2b-74d8-b1c0-75f09c60418d.webp",
        "width": 1500,
        "height": 1001
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sacramento Airport",
      "seo_description": "Find stylish apartments at Zinfandel Village, close to Sacramento International Airport, offering easy travel and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5602"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10528418398"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5TWXGWWH"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "51978104245"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-651-0875"
    }
  ],
  "custom_qb_id": "5602",
  "custom_repli_id": "10528418398",
  "custom_google_gtm_id": "GTM-5TWXGWWH",
  "custom_hubspot_company_id": "51978104245",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-651-0875"
};

export const generatedAt = '2026-09-23T19:57:40.296Z';
